// 中文（简体）翻译。
// 与 en-US.ts 保持 key 结构完全一致 —— 加新文案两边都要补。
export default {
  common: {
    loadFailed: '加载失败',
    deleted: '已删除',
    save: '保存',
    cancel: '取消',
    confirm: '确定',
    delete: '删除',
    edit: '编辑',
    create: '新建',
    refresh: '刷新',
    submit: '提交',
    loading: '加载中…',
    empty: '暂无数据',
    actions: '操作',
    status: '状态',
    name: '名称',
    type: '类型',
    yes: '是',
    no: '否',
    on: '开启',
    off: '关闭',
    search: '搜索',
    copy: '复制',
    copied: '已复制',
    back: '返回',
    next: '下一步',
    more: '更多',
  },
  app: {
    switchLanguage: '切换到 English',
    title: 'cdnX 控制台',
    logout: '退出登录',
    fullscreen: '全屏',
    exitFullscreen: '退出全屏',
    openMenu: '打开菜单',
    collapseMenu: '收起菜单',
    expandMenu: '展开菜单',
    foldMenu: '收起',
    search: '搜索',
    searchPlaceholder: '支持按页面名、站点域名搜索',
    searchHint: '输入页面或站点名称；按 / 随时打开',
    searchNoHit: '没有匹配的结果',
    searchPage: '页面',
    searchSite: '站点',
    notifications: '消息通知',
    toDashboard: '查看仪表盘',
    pageSettings: '自定义设置',
  },
  navbar: {
    store: '套餐',
    billing: '费用',
    tickets: '工单',
    accountId: '账号 ID {id}',
    accountIdFull: '账号 ID：{id}',
    subAccountId: '子用户 · 账号 ID {id}',
    subUser: '子用户',
    subOwner: '主账号 {name}（ID {id}）',
    rnIndividual: '个人认证',
    rnEnterprise: '企业认证',
    rnPending: '认证审核中',
    rnRejected: '认证未通过',
    rnNone: '未实名认证',
    rnGo: '去认证',
    balance: '可用余额（元）',
    showBalance: '显示余额',
    hideBalance: '隐藏余额',
    topUp: '充值',
    monthSpent: '本月消费：{n}',
    updatedAt: '更新时间：{t}',
    unpaid: '待支付',
    toRenew: '待续费',
    ticketsTodo: '待办工单',
    unread: '未读消息',
    renewals: '续费管理',
    myOrders: '我的订单',
    invoiceable: '可开发票（元）',
    cashable: '可提现（元）',
    toFinance: '前往财务管理',
  },
  nav: {
    dashboard: '仪表盘',
    domains: '站点列表',
    rules: '规则',
    domain: '站点详情',
    login: '登录',
  },
  register: {
    title: '创建账户',
    subtitle: '创建一个新账号',
    email: '邮箱',
    emailUnverified: '系统暂未开通邮件功能，此邮箱不会收到验证邮件。',
    confirmPassword: '确认密码',
    passwordHelp: '至少 {n} 位。',
    passwordMismatch: '两次输入的密码不一致',
    passwordTooShort: '密码至少需要 {n} 位',
    submit: '注册',
    success: '注册成功，请登录',
    failed: '注册失败',
    closed: '本平台当前未开放自助注册，请联系管理员开通账号。',
    backToLogin: '返回登录',
    usernamePlaceholder: '请输入用户名',
    usernameRequired: '请输入用户名',
    emailPlaceholder: '请输入邮箱',
    emailRequired: '请输入邮箱',
    emailCodePlaceholder: '邮箱验证码',
    emailCodeRequired: '请输入 6 位邮箱验证码',
    phonePlaceholder: '请输入手机号码',
    phoneRequired: '请输入手机号码',
    smsCodePlaceholder: '短信验证码',
    passwordPlaceholder: '至少 {min} 位，字母/数字/符号任两种',
    passwordRequired: '请设置登录密码',
    confirmPlaceholder: '确认密码',
    welcome: '注册成功，欢迎使用',
  },
  ipLists: {
    title: 'IP 名单',
    introAdmin: '全系统黑白名单。这里的条目对所有节点、所有站点生效，并会下发到 nftables 在内核层拦截。',
    introUser: '账号级黑白名单。这里的条目对您名下所有站点生效。',
    searchPlaceholder: '搜索地址或备注',
    checkEmpty: '不能为空',
    checkBadAddress: '不是有效的 IP 地址',
    checkBadCidr: '网段格式不正确',
    checkTooBroad: '/{bits} 太宽，最小 /{min}',
    checkDuplicate: '与上面重复',
    problemsHead: '有 {n} 处需要修改，修改后才能提交：',
    lineNo: '第 {n} 行',
    fixProblemsFirst: '请先修正标出的问题',
    batchAddedSkipped: '已添加 {n} 条，{s} 条已存在已跳过',
    modeSingle: '单个',
    modeBatch: '批量',
    bulkPlaceholder: '一行一个，例如：\n1.2.3.4\n10.0.0.0/8\n2001:db8::/32',
    bulkHelp: '已识别 {n} 条，单次最多 {max} 条。逗号分隔也可以。',
    batchAdded: '已添加 {n} 条',
    addDeny: '添加黑名单',
    addAllow: '添加白名单',
    targetRequired: '请填写 IP 或网段',
    noMatch: '没有匹配的记录',
    empty: '暂无记录',
    tabDeny: '黑名单',
    tabAllow: '白名单',
    enforceKernel: '内核级封禁',
    enforceEdge: '普通封禁',
    enforcementCol: '封禁方式',
    enforcementNote: '内核级封禁在 nftables 里直接丢包，攻击流量不消耗节点的 TLS 握手和 CPU，但对整个节点生效（内核不知道包是发给哪个站点的）。只拦截访问 80/443 端口的流量，SSH 和节点与主控的通信不受影响。普通封禁在边缘拒绝，请求仍要走完握手。',
    userKernelHint: '命中黑名单的请求在节点上直接被拒绝，不会到达源站。',
    tabAuto: '自动封禁',
    allowNote: '白名单优先级最高：命中白名单的地址不会被任何黑名单、CC 封禁、WAF 或人机验证拦下。适合用于监控探测、支付回调这类不能误伤的来源。',
    autoNote: 'CC 防护自动封禁的地址，已下发到节点内核并带有效期。到期内核会自己清除；提前解封会同时下发一个任务通知对应节点移除。',
    activeOnly: '只看生效中',
    add: '添加',
    added: '已添加',
    addFailed: '添加失败',
    targetPlaceholder: 'IP 或网段，如 1.2.3.4 或 10.0.0.0/8',
    notePlaceholder: '备注（可选）',
    targetCol: '地址',
    noteCol: '备注',
    addedCol: '添加时间',
    ipCol: 'IP',
    nodeCol: '节点',
    domainCol: '域名',
    ruleCol: '触发规则',
    bannedAtCol: '封禁时间',
    expiresCol: '到期时间',
    release: '解封',
    released: '已解封',
    releaseQueued: '已解封，正在通知节点移除',
    releaseRecorded: '已记录解封，但未能通知节点，内核封禁将在到期后自动清除',
    releaseFailed: '解封失败',
    confirmDeleteTitle: '删除这条记录？',
    confirmDelete: '将从名单中移除 {target}，配置会重新下发到节点。',
    statTotal: '名单条目',
    statCap: '上限 {n} 条',
    statToday: '今日新增',
    listCount: '共 {n} 条',
    typeCol: '类型',
    typeIp: 'IP',
    typeCidr: '网段',
  },
  auth: {
    createAccount: '还没有账号？立即注册',
    welcomeBack: '欢迎回来',
    loginFailed: '登录失败',
    signInSubtitle: '登录到 {name} 控制台',
    username: '用户名',
    password: '密码',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入登录密码',
    signIn: '登录',
    unauthorized: '未授权或会话已过期，请重新登录',
    mfaLabel: '动态码',
    mfaHint: '打开身份验证器应用，输入显示的 6 位动态码',
    mfaVerify: '验证',
    mfaBack: '返回重新登录',
    smsLabel: '短信验证码',
    smsHint: '验证码将发送至 {phone}',
    smsSentHint: '验证码已发送至 {phone}，{minutes} 分钟内有效',
    useSms: '改用短信验证码',
    useMfa: '改用 MFA 动态码',
    forgot: '忘记密码',
    resetSubtitle: '通过已验证的手机号重置密码',
    resetCodeHint: '验证码会发送到这个账号已验证的手机号',
    resetSubmit: '重置密码',
    resetDone: '密码已重置，请使用新密码登录',
    resetFailed: '重置失败',
    backToSignIn: '返回登录',
    welcome: '欢迎登录',
    secondTitle: '安全验证',
    secondHint: '为了保障您的账号安全，请完成身份验证',
    resetTitle: '找回密码',
    identityPlaceholder: '请输入手机 / 邮箱 / 用户名',
    identityRequired: '请输入手机、邮箱或用户名',
    passwordRequired: '请输入登录密码',
    remember: '7 天内自动登录',
    noAccount: '没有账户？',
    registerNow: '现在注册',
    backToSite: '返回官网',
    otherLanguage: 'English',
    agreeNotice: '登录即表示您已阅读并同意',
    agreeConsent: '我已阅读并同意',
    agreeAnd: '和',
    terms: '《用户使用条款》',
    privacy: '《隐私政策》',
    termsTitle: '用户使用条款',
    privacyTitle: '隐私政策',
    agreementOk: '我知道了',
    agreementAgree: '同意',
    agreementFailed: '协议加载失败，请稍后重试',
    noticeClose: '关闭公告',
    tabPassword: '密码登录',
    tabCode: '验证码登录',
    codeTarget_phone: '请输入手机号',
    codeTarget_email: '请输入邮箱',
    codeTarget_any: '请输入手机号或邮箱',
    codeTargetRequired_phone: '请输入手机号',
    codeTargetRequired_email: '请输入邮箱',
    codeTargetRequired_any: '请输入手机号或邮箱',
    otherWays: '其他登录方式',
    waySub: '子用户',
    wayPasskey: '通行密钥',
    subTitle: '子用户登录',
    subHint: '使用主账号为您创建的子用户登录',
    subOwnerPlaceholder: '请输入主账号 ID 或用户名',
    subNamePlaceholder: '请输入子用户名',
    subOwnerRequired: '请输入主账号 ID 或用户名',
    subNameRequired: '请输入子用户名',
    subBack: '返回主账号登录',
    passkeyCancelled: '已取消通行密钥登录',
    passkeyBlocked_browser: '当前浏览器不支持通行密钥，请升级浏览器或改用其他方式登录',
    passkeyBlocked_domain: '通行密钥需要通过 HTTPS 域名访问控制台，当前地址无法使用',
  },
  dashAccount: {
    balance: '可用余额(元)',
    spent: '本月消费(元)',
    updated: '{time} 更新',
    orders: '查订单',
    ledger: '查收支',
    invoices: '查发票',
    packages: '查套餐',
    unpaid: '待支付订单',
    toRenew: '待续费套餐',
    ticketsTodo: '待我回复的工单',
    invoiceable: '可开票金额(元)',
    cashable: '可提现金额(元)',
    phoneBound: '已绑定手机',
    phoneUnbound: '未绑定手机',
    guarded: '已开启登录保护',
    unguarded: '未开启登录保护',
    tipRenewShort: '续费失败，余额不足',
    tipRenewFailed: '套餐自动续费未成功',
    tipAutoRenew: '推荐开启自动续费',
    tipGuard: '推荐开启登录保护',
    topUp: '前往充值',
    view: '前往查看',
    setUp: '前往设置',
  },
  dashboard: {
    welcome: '欢迎回来，{name}',
    sites: '站点数量',
    unitSites: '个',
    hostnames: '加速域名',
    unitHostnames: '个',
    certs: 'SSL 证书',
    unitCerts: '张',
    certsDue: '{n} 张待续期',
    subscriptions: '生效套餐',
    unitSubs: '份',
    subsDue: '{n} 份即将到期',
    trafficUsed: '本期流量',
    requestsUsed: '本期请求',
    usageOf: '已用 {pct}',
    usageUnlimited: '不限量',
    usageNone: '暂无生效套餐',
    today: '今日',
    trend: '用量趋势',
    trendTotal: '近 {days} 天 · 共 {total}',
    trendPeak: '近 {days} 天 · 峰值 {total}',
    metric_traffic: '流量',
    metric_requests: '请求数',
    metric_bandwidth: '峰值带宽',
    series_traffic: '流量',
    series_requests: '请求数',
    series_bandwidth: '峰值带宽',
    last7: '近 7 天',
    last30: '近 30 天',
    viewMore: '查看更多',
    noLogs: '未接入日志存储，暂无用量数据',
    topSites: 'TOP10 数据',
    topUnavailable: '未接入日志存储，暂无访问排行',
    siteStatus: '站点状态',
    siteActive: '正常',
    siteDraft: '配置中',
    siteSuspended: '已暂停',
    siteDisabled: '已禁用',
    certStatus: '证书状态',
    certValid: '有效',
    certExpiring: '即将到期',
    certExpired: '已过期',
    codeStatus: '今日状态码',
    codeCaption: '请求数',
    codeOk: '2xx/3xx',
    code4xx: '4xx',
    code5xx: '5xx',
    allClear: '一切正常，没有需要处理的事项',
    tag_cert: '证书',
    tag_site: '站点',
    tag_sub: '套餐',
    tag_quota: '用量',
    sitesSuspended: '{n} 个站点已暂停服务',
    certsExpired: '{n} 张证书已过期',
    certsExpiring: '{n} 张证书 14 天内到期',
    subsExpiring: '{n} 份套餐 7 天内到期',
    autoRenewFailed: '{n} 份套餐自动续费未成功',
    sitesDraft: '{n} 个站点 CNAME 未生效',
    trafficHigh: '本期流量已用 {n}',
    requestsHigh: '本期请求已用 {n}',
    statsChNotConfigured: '尚未配置 ClickHouse。请在 control.yaml 中设置 clickhouse.addr，然后运行 cdnx-migrate ch-up 启用分析。',
    tag_ticket: '工单',
    ticketsReplied: '{n} 个工单有新回复',
  },
  layout: {
    navbarHeight: '导航栏高度',
    menuWidth: '菜单宽度',
    colorWeak: '色弱模式',
    grayscale: '灰色模式',
  },
  custom: {
    notify: '消息提醒',
    sound: '新消息提示音',
    soundDesc: '工单收到新回复时播放提示音',
    speech: '语音播报',
    speechDesc: '收到新回复时朗读“您有一条新的工单消息”',
    title: '自定义设置',
    theme: '主题',
    theme_light: '浅色模式',
    theme_dark: '深色模式',
    theme_twotone: '双色模式',
    navbar: '顶部导航',
    navbar_on: '显示导航栏',
    navbar_onDesc: '顶部显示搜索、消息通知与账号',
    navbar_off: '隐藏导航栏',
    navbar_offDesc: '内容区更大，从右下角按钮打开本设置',
    menu: '侧边菜单',
    menu_on: '显示菜单',
    menu_onDesc: '在页面左侧显示导航菜单',
    menu_off: '隐藏菜单',
    menu_offDesc: '隐藏左侧菜单，内容占满宽度',
    pageTitle: '页面标题',
    pageTitle_on: '显示页面标题',
    pageTitle_onDesc: '在内容区顶部显示当前页面名称',
    pageTitle_off: '隐藏页面标题',
    pageTitle_offDesc: '不显示页面名称，内容更紧凑',
    access: '辅助功能',
    fullscreenDesc: '控制台占满整个屏幕，按 Esc 退出',
    colorWeakDesc: '反转色彩，便于色弱用户分辨',
    grayscaleDesc: '以灰度显示整个控制台',
    reset: '恢复默认设置',
  },
  monitor: {
    title: '监控趋势',
    bandwidth: '峰值带宽',
    requests: '请求数',
    traffic: '流量',
    blocked: '拦截次数',
    blockedIps: '拦截 IP 数',
    hits: '缓存命中',
    range_1h: '1 小时',
    range_today: '今日',
    range_yesterday: '昨日',
    range_7d: '7 天',
    range_30d: '30 天',
    window_1h: '近 1 小时',
    window_today: '今日',
    window_yesterday: '昨日',
    window_7d: '近 7 天',
    window_30d: '近 30 天',
    vs_1h: '较上一小时',
    vs_today: '较昨日同时段',
    vs_yesterday: '较前日',
    vs_7d: '较前 7 天',
    vs_30d: '较前 30 天',
    unitTimes: '次',
    unitIps: '个',
    loadFailed: '监控数据加载失败',
    noLogs: '未接入日志存储，暂无带宽、请求、流量、拦截和缓存命中数据',
  },
  top: {
    dim_domain: '域名',
    dim_url: 'URL',
    dim_ip: 'IP',
    dim_country: '国家',
    dim_province: '省份',
    dim_status: '状态码',
    dim_isp: '运营商',
    dim_referer: '来源',
    direct: '直接访问',
    unknown: '未知',
    requests: '请求',
    traffic: '流量',
  },
  stats: {
    title: '数据统计',
    denyIps: 'IP 黑名单',
    allowIps: 'IP 白名单',
    credentials: 'API 密钥',
    cacheJobs: '今日刷新',
    unitEntries: '条',
    unitItems: '个',
    unitTimes: '次',
  },
  sitePanel: {
    title: '站点概况',
    summary: '{active} / {total} 正常 · 今日数据',
    state_active: '正常',
    state_draft: '配置中',
    state_suspended: '已暂停',
    state_disabled: '已禁用',
    aliases: '+{n}',
    aliasesTip: '另有 {n} 个别名',
    requests: '请求',
    traffic: '流量',
    hitRate: '命中率',
    empty: '还没有站点。',
    add: '新建站点',
  },
  packageCard: {
    title: '我的套餐',
    state_active: '生效中',
    state_expiring: '即将到期',
    state_expired: '已到期',
    traffic: '本期流量',
    requests: '本期请求',
    unlimited: '不限',
    expiresAt: '到期时间',
    daysLeft: '剩 {n} 天',
    dueToday: '今日到期',
    expiredShort: '已到期',
    resetsAt: '本期重置',
    sites: '站点',
    sitesValue: '{n} 个',
    none: '还没有生效中的套餐，新建站点前需要先开通套餐。',
    expiredNote: '套餐已到期，它下面的站点已暂停服务，续费后一分钟内自动恢复。',
    exceededNote: '本期额度已用完，它下面的站点已暂停服务，下个周期自动恢复。',
  },
  siteCerts: {
    daysLeft: '剩余 {n} 天',
    expiresToday: '今天到期',
    expiredDays: '已过期 {n} 天',
    hostCount: '共 {n} 个域名',
    intro: '每个域名可以单独配置证书。免费证书由平台自动签发、自动续期；自定义证书需要在证书管理页面上传，过期前自行更换。',
    applyFree: '申请免费证书',
    blockedUnverified: '域名通过 CNAME 验证后才能申请证书',
    blockedSiteOff: '站点已停用，暂时不能申请证书',
    useExisting: '选择已有证书',
    hostCol: '域名',
    certCol: '证书',
    typeCol: '类型',
    statusCol: '状态',
    expiresCol: '到期时间',
    primary: '主域名',
    typeFree: '免费证书',
    typeCustom: '自定义证书',
    stateOk: '正常',
    stateExpiring: '即将过期',
    stateExpired: '已过期',
    stateMismatch: '证书不匹配',
    stateNone: '未配置',
    issuing: '签发中',
    issueFailed: '签发失败',
    issueCancelled: '已取消签发',
    issuingAttempt: '正在签发（第 {n}/{max} 次尝试）',
    nextRun: '下次重试：{t}',
    retryNow: '立即重试',
    apply: '申请证书',
    change: '更换',
    choose: '选择证书',
    unbind: '解除绑定',
    unbindTitle: '解除证书绑定',
    unbindContent: '解除后 {host} 会自动改用站点里覆盖它的最新证书；没有的话 HTTPS 将无法访问。',
    issuer: '颁发机构',
    validity: '有效日期',
    algorithm: '证书算法',
    source: '来源',
    source_bound: '手动指定',
    source_auto: '自动匹配（站点内覆盖该域名的最新证书）',
    source_fallback: '没有覆盖该域名的证书，临时使用站点最新证书',
    source_none: '—',
    mismatchHint: '当前没有覆盖 {host} 的证书，节点暂时用站点的其他证书响应，浏览器会提示证书错误。请为它申请或选择一张证书。',
    noCert: '还没有证书，点击「申请证书」或「选择证书」',
    pickHost: '请选择域名',
    pickCert: '请选择证书',
    bindHint: '只列出覆盖这个域名、并且仍然有效的证书。证书在证书管理页面上传。',
    noBindable: '没有覆盖这个域名的有效证书',
    bound: '已应用',
    issueQueued: '已加入签发队列，状态会显示在列表里',
    issueQueueHint: '签发在后台队列执行，可以关闭这个窗口。失败原因会显示在对应域名的展开行里。',
    notInPackage: '套餐不支持上传证书',
  },
  geoBlock: {
    title: '区域屏蔽',
    mode: '屏蔽模式',
    modes: { off: '关闭', block: '屏蔽所选地区', allow: '仅允许所选地区' },
    modeHint_off: '不按国家或地区限制访问。',
    modeHint_block: '来自所选国家或地区的访问按下方方式处置，其它地区正常访问。',
    modeHint_allow: '只有所选国家或地区可以正常访问，其它地区一律按下方方式处置。例如只勾选「中国」即为屏蔽海外。',
    action: '处置方式',
    actions: {
      drop: '丢弃连接（444）',
      deny: '拦截（403）',
      challenge_js: 'JS 验证',
      challenge_slider: '滑动验证',
      ban_kernel: '内核级封禁',
      log: '仅记录',
    },
    actionHint_drop: '不返回任何内容，直接断开连接。比 403 省资源，也不向对方透露任何信息。',
    actionHint_deny: '返回 403 状态码，访客能看到被拒绝了。',
    actionHint_ban_kernel: '第一次访问断开连接，同时把这个 IP 交给节点防火墙（nftables）。之后它的数据包在内核里直接丢弃，不再占用代理任何资源。',
    actionHint_challenge_js: '先通过 JS 验证才能访问，通过后在免验时长内不再验证。',
    actionHint_challenge_slider: '先拖动滑块通过验证才能访问，通过后在免验时长内不再验证。',
    actionHint_log: '不拦截，只在安全事件里记录。适合正式开启前先观察会影响多少访问。',
    banSeconds: '封禁时长（秒）',
    banSecondsHint: '60 秒到 30 天。到期后自动解除，在封禁日志里可以提前解除。',
    kernelWarn: '内核级封禁作用于整台节点：防火墙分不清数据包是访问哪个站点的，被封的 IP 在这台节点上的所有站点都打不开，不只是本站。只有这台节点上的站点都应当拒绝这些地区时再用。',
    regionsBlock: '要屏蔽的地区',
    regionsAllow: '允许访问的地区',
    levelCountry: '国家/地区（{count}）',
    levelProvince: '中国省份（{count}）',
    levelCity: '城市（{count}）',
    rowCountries: '国家/地区（{count}）',
    rowProvinces: '中国省份（{count}）',
    rowCities: '城市（{count}）',
    allProvinces: '中国内地全部 {count} 个省份',
    useCountryInstead: '改为整体选择「中国」（不依赖城市库，更准确）',
    unfold: '展开全部 {count} 个',
    fold: '收起',
    levelProvinceAll: '中国省份（全部）',
    provincesCovered: '已整体选择「中国」，所有省份都已包含。只想针对部分省份时，先在「国家/地区」里取消中国。',
    cityCovered: '已整体选择「{country}」，它的所有城市都已包含，不需要再单独添加。',
    summaryAllow: '只有来自 {places} 的访客可以访问，其他地区一律按「{action}」处置。',
    summaryBlock: '来自 {places} 的访客按「{action}」处置，其他地区正常访问。',
    summaryMore: '{list} 等 {count} 处',
    nothingSelected: '还没有选择任何地区',
    provinceHint: '中国内地 31 个省、自治区、直辖市。香港、澳门、台湾在「国家/地区」里选。',
    cityPlaceholder: '城市名，如 深圳 或 Shenzhen',
    addCity: '添加',
    cityHint: '按 GeoIP 数据库里的中文或英文城市名匹配，「市」「地区」等后缀写不写都可以。同名城市按所选国家区分。最多 200 个。',
    searchPlaceholder: '搜索国家/地区名称或代码',
    addGreaterChina: '+ 中国内地及港澳台',
    selectAll: '全选',
    clearAll: '清空',
    selectContinent: '全选本洲',
    clearContinent: '清空本洲',
    noMatch: '没有匹配的国家或地区',
    continents: { AS: '亚洲', EU: '欧洲', NA: '北美洲', SA: '南美洲', AF: '非洲', OC: '大洋洲', AN: '南极洲' },
    notesTitle: '说明',
    noteUnknown: '按访客 IP 判断所在国家或地区。无法判断的 IP（节点未安装 GeoIP 数据库、内网地址等）一律放行，不论哪种模式。',
    noteCityDb: '省份和城市需要节点装有 GeoLite2-City 数据库，没有时判断不出访客在哪个省市，这些条目一律放行；「仅允许」模式下就相当于只按国家判断。',
    noteWhitelist: 'IP 白名单中的地址不受区域屏蔽限制，可以用来放行被屏蔽地区里的合作方。',
    noteOrder: '区域屏蔽在强制验证和 CC、WAF 等规则之前执行，被拦截的访问不会再进入后续检查。',
    saved: '区域屏蔽设置已保存',
    saveFailed: '保存区域屏蔽设置失败',
  },
  cacheJobs: {
    targetsCount: '{n} 条',
    progress: '{done}/{total} 个节点',
    historyCount: '共 {n} 条',
    section: '缓存刷新',
    intro: '刷新会让节点丢弃已缓存的内容，下次访问重新回源；预热则提前把内容拉到节点，让首次访问就命中。任务会下发到所有节点，某个节点离线时任务会排队，等它回来再执行。',
    kind: '类型',
    sectionPurge: '缓存刷新',
    sectionPrefetch: '缓存预热',
    prefetchIntro: '提前把内容拉到各节点，让首次访问就命中缓存。适合在版本发布或活动开始前把新资源预先铺开。',
    modeNow: '即时预热',
    modeScheduled: '定时预热',
    scheduledAt: '执行时间',
    scheduledHint: '任务会在这个时间自动下发到所有节点，最多可提前 30 天安排。',
    scheduledRequired: '请选择执行时间',
    prefetchHistory: '预热记录',
    purgeHistory: '刷新记录',
    status_scheduled: '等待执行',
    scheduledFor: '计划于 {t}',
    emptyPrefetch: '暂无预热任务',
    kindPurgeUrl: '刷新 URL',
    kindPurgeDir: '刷新目录',
    kindPurgeAll: '刷新全站',
    kindPrefetch: '预热 URL',
    kind_purge_url: '刷新 URL',
    kind_purge_dir: '刷新目录',
    kind_purge_all: '刷新全站',
    kind_prefetch: '预热',
    targets: '目标',
    targetsPlaceholder: '一行一个，例如：\n/index.html\n/assets/app.js\nhttps://example.com/logo.png',
    targetsDirPlaceholder: '一行一个目录，例如：\n/assets/\n/static/img/',
    targetsHelp: '已识别 {n} 条，单次最多 1000 条。可以填路径或完整 URL，URL 的域名必须是本站点。',
    purgeAllWarning: '将丢弃本站点在所有节点上的全部缓存。之后一段时间内所有请求都会回源，源站负载会明显上升，请避开业务高峰。',
    submit: '提交',
    scheduledOk: '已排期，到时间会自动下发到各节点',
    submitted: '已提交，正在下发到各节点',
    submitFailed: '提交失败',
    history: '任务记录',
    nodes: '节点进度',
    failedN: '{n} 失败',
    status_pending: '等待中',
    status_running: '执行中',
    status_done: '已完成',
    status_failed: '部分失败',
    createdAt: '提交时间',
    wholeSite: '（全站）',
    empty: '暂无任务',
  },
  challenge: {
    title: '强制验证',
    desc: '开启后，所有访问者必须先通过人机验证才能访问站点。已通过的访问者在有效期内不再重复验证。',
    warn: '这会改变每一个访问者看到的第一个页面。开启前请确认下方的搜索引擎放行和路径豁免配置正确，否则可能影响收录或打断 API 调用。',
    mode: '验证方式',
    mode_wait: '5 秒盾',
    mode_js: 'JS 验证',
    mode_click: '点击验证',
    mode_slider: '滑动验证',
    modeHint_wait: '显示"正在检查浏览器"，后台完成计算后自动放行，访问者无需操作。',
    modeHint_js: '同 5 秒盾，但显示计算进度。',
    modeHint_click: '访问者需要点击一次按钮。计算在页面加载时完成，点击只是确认。',
    modeHint_slider: '访问者需要把滑块拖到最右侧。',
    ttl: '免验时长（秒）',
    ttlHint: '通过后多久内不再要求验证。默认 1800 秒（30 分钟）。',
    difficulty: '计算难度',
    difficultyHint: '每提高 1，机器人的计算成本翻倍。默认 16，现代浏览器约几十毫秒。低于 12 几乎没有防护效果，高于 20 低端手机会明显卡顿。',
    bypassSpiders: '放行搜索引擎',
    bypassSpidersHint: '通过反查 DNS 验证真实身份的搜索引擎蜘蛛直接放行（伪造 UA 的仍会被拦）。关闭此项会导致站点从搜索引擎索引中消失，因为爬虫不执行 JS。',
    exemptPaths: '豁免路径',
    exemptPathsHint: '每行一个路径前缀，命中的请求跳过验证。API 接口、支付回调、健康检查必须加在这里——它们不是浏览器，永远通不过验证。按路径段匹配：/api 会豁免 /api/orders，但不会豁免 /apiary。',
    saved: '已保存并下发',
    saveFailed: '保存失败',
  },
  ccProtection: {
    title: 'CC 防护',
    level: '防护等级',
    levels: { off: '关闭', loose: '宽松', normal: '正常', strict: '严格', attack: '攻击紧急' },
    levelHint_off: '不启用内置防护，只执行下方的自定义规则。',
    levelHint_loose: '单 IP 10 秒内超过 600 次请求弹出 JS 验证。几乎不会误伤，适合流量大、接口多的站点。',
    levelHint_normal: '单 IP 10 秒内超过 300 次请求，5 分钟内的请求都需要通过 JS 验证；反复触发 5 次封禁 10 分钟。',
    levelHint_strict: '单 IP 10 秒内超过 120 次请求，10 分钟内都需要通过 JS 验证；反复触发 3 次内核级封禁 30 分钟。',
    levelHint_attack: '全站强制 JS 验证；单 IP 10 秒内超过 60 次请求，15 分钟内都需要滑块验证；反复触发 2 次内核级封禁 1 小时。',
    attackWarn: '攻击紧急模式会让所有访客先通过验证，API 和无法执行 JS 的客户端会受影响，攻击结束后请及时调回。',
    auto: '自适应 CC',
    autoHint_off: '不会自动开启。遭受 CC 攻击时，需要手动把防护等级切到「攻击紧急」。',
    autoHint_loose: '请求量达到平时的 6 倍、同时源站一半请求失败或明显变慢时，自动对新访客开启验证。适合流量波动大的站点。',
    autoHint_normal: '请求量达到平时的 4 倍、同时源站开始报错或变慢时，自动对新访客开启验证；请求量恢复正常 5 分钟后自动关闭。',
    autoHint_strict: '请求量达到平时的 2.5 倍、同时源站稍有异常时，就对新访客开启验证。适合源站承载能力较弱的站点。',
    autoCommon: '各节点按本站平时的请求量和源站响应速度判断。已通过验证的访客、豁免路径和搜索引擎不受影响。',
    autoMode: '验证方式',
    autoActiveTitle: '自动防护中',
    autoActive: '{nodes} 个节点从 {since} 起对新访客开启了验证，触发原因：{reason}。目前每秒 {rps} 个请求，平时约 {baseline} 个。请求量恢复正常 5 分钟后自动关闭。',
    autoReason_failing: '源站请求大量失败',
    autoReason_slow: '源站响应明显变慢',
    autoMoot: '防护等级为「攻击紧急」或已开启强制验证时，所有新访客都会先验证，自适应 CC 不会再额外起作用。',
    failBan: '验证失败封禁',
    failBanDesc: '同一 IP 在统计周期内验证失败达到次数后，加入黑名单：节点直接下发内核级拦截，并记录到封禁日志。对强制验证和 CC 规则弹出的验证都生效。',
    failMax: '失败次数',
    failMaxHint: '拿到验证页却不通过、或提交错误答案都计一次，通过后清零。',
    failWindow: '统计周期（秒）',
    failBanSec: '封禁时长（秒）',
    failBanSecHint: '最长 30 天。',
    saved: 'CC 防护设置已保存',
    saveFailed: '保存 CC 防护设置失败',
  },
  domains: {
    packageCol: '所属套餐',
    switchPackage: '切换',
    switchTitle: '切换 {name} 的套餐',
    switchExpires: '有效期至 {time}',
    switchCurrent: '当前',
    switchNote: '切换后，站点马上改用新套餐的流量、请求数、带宽和连接数配额。如果新套餐的接入线路不同，会生成新的 CNAME 地址：旧地址继续可用，把 DNS 改成新地址后才会走新线路。',
    switchDone: '已切换套餐',
    switchCnameTitle: 'CNAME 地址已更新',
    switchCnameChanged: '{name} 的新 CNAME 地址是 {new}。请到域名的 DNS 服务商把 CNAME 记录改成这个地址，之后访问会走新套餐的线路。改好之前，旧地址 {old} 继续可用，网站不会中断。',
    suspended_plan_expired: '已暂停：套餐到期',
    suspended_traffic_exceeded: '已暂停：流量超限',
    suspended_requests_exceeded: '已暂停：请求数超限',
    suspendedTip: '访问者看到的是「网站已暂停服务」页面。续费（重新购买套餐）后一分钟内自动恢复。',
    title: '站点',
    add: '新建站点',
    addModalTitle: '新建站点',
    addPlaceholder: '例如 cdn.example.com',
    nameLabel: '主域名',
    nameCol: '主域名',
    statusCol: '状态',
    sslCol: 'SSL',
    sslModeCol: 'SSL 模式',
    proxyModeCol: '代理模式',
    publishCol: '版本',
    liveVersionCol: '已发布版本',
    rules: '规则',
    publish: '发布',
    publishSuccess: '发布成功',
    publishedTo: '已发布 {version}',
    publishFailed: '发布失败',
    nameRequired: '请填写域名',
    packageLabel: '所属套餐',
    packagePlaceholder: '选择一个当前生效中的套餐',
    packageRequired: '请选择套餐',
    noActivePackageHint: '你还没有生效中的套餐，请先购买套餐后再新建站点',
    requestSSL: '申请证书',
    createSuccess: '站点已创建',
    createFailed: '创建站点失败',
    statusDraft: '配置中',
    statusPendingVerify: '待验证',
    statusActive: '生效中',
    statusPaused: '已暂停',
    statusDisabled: '已禁用',
    disable: '禁用',
    enable: '启用',
    disableConfirmTitle: '禁用站点',
    disableConfirmContent: '确定禁用「{name}」吗？禁用后该站点的流量将不再被代理。',
    disableSuccess: '已禁用',
    disableFailed: '禁用失败',
    enableSuccess: '已启用',
    enableFailed: '启用失败',
    aliasDeleteConfirm: '删除域名 {host}？节点将不再响应它。',
    originDeleteConfirm: '删除源站 {addr}？',
    originAddrRequired: '请填写源站地址',
    deleteSite: '删除站点',
    changePackageAction: '更换套餐',
    listTitle: '全部站点',
    listCount: '共 {n} 个',
    listFiltered: '筛选后 {n} 个',
    searchPlaceholder: '搜索主域名或 CNAME',
    filterAllPackages: '全部套餐',
    filterAllStatus: '全部状态',
    filterAllSsl: '全部 SSL 模式',
    filterSuspended: '已暂停',
    resetFilters: '重置',
    statTotal: '站点总数',
    statToday: '今日 +{n}',
    statActive: '生效中',
    statDraft: '配置中',
    statDisabled: '已禁用',
    statSuspended: '{n} 个已暂停',
    statDraftNote: '等待解析 CNAME',
    siteCol: '站点',
    createdAtCol: '创建时间',
    updatedAtCol: '最近修改',
    more: '更多',
    ssl_off: '关闭',
    ssl_flexible: '灵活',
    ssl_full: '完全',
    ssl_strict: '完全（严格）',
    ssl_force_https: '强制 HTTPS',
    sslHint_off: '访客只能用 HTTP 访问，节点不监听 HTTPS。',
    sslHint_flexible: '访客到节点 HTTPS，节点到源站 HTTP。源站没有证书时用。',
    sslHint_full: '访客到节点、节点到源站都走 HTTPS，不校验源站证书，自签证书也可以。',
    sslHint_strict: '全程 HTTPS，并校验源站证书必须有效且与回源 Host 匹配。',
    sslHint_force_https: '全程 HTTPS，HTTP 访问 301 跳转到 HTTPS；回源不校验源站证书。',
    proxy_proxy: '代理加速',
    proxy_dns_only: '仅 DNS',
    proxyHint_proxy: '流量经过节点，缓存、防护规则和证书都在节点上生效。',
    proxyHint_dns_only: '只保留解析记录，流量直达源站，节点上的配置不生效。',
    realIpHeaderHint: '节点把访客真实 IP 放进这个请求头转给源站，源站按它取客户端地址。',
    hostCol: '域名',
    hostTypeCol: '类型',
    primaryTag: '主域名',
    aliasTag: '附加域名',
    aliasCount: '共 {n} 个域名',
    hostVerifyCol: '解析验证',
    hostVerified: '已验证',
    hostPending: '待验证',
    hostForced: '强制生效',
    hostForcedTip: '平台管理员跳过了 CNAME 验证，直接生效',
    hostPendingTip: '把 {host} 的 CNAME 指向 {target}，系统会自动检查；改好后也可以点「验证」立即检查。',
    hostPrimaryPendingTip: '主域名在「概览」的 CNAME 解析里验证。',
    hostNoTargetTip: '站点还没有 CNAME 地址，暂时无法验证。',
    aliasVerify: '验证',
    aliasVerified: '{host} 已通过验证，节点开始加速',
    aliasVerifyMismatch: 'CNAME 还没有指向本站',
    aliasVerifyFailed: '验证失败',
    addOrigin: '添加源站',
    addOriginTitle: '添加源站',
    originScheme: '协议',
    originPort: '端口',
    originWeight: '权重',
    originRole: '角色',
    originPrimary: '主源站',
    originBackup: '备用源站',
    originBackupLabel: '作为备用源站',
    originBackupHint: '只有主源站全部不可用时才会用到它。',
    originWeightHint: '多个主源站之间按权重分配请求。',
    originSni: 'SNI',
    originAddrPlaceholder: 'IP 或域名，例如 10.0.0.8 或 origin.example.com',
    originStatus_active: '启用',
    originStatus_disabled: '停用',
    originCount: '共 {n} 个源站',
    basicSettings: '基础设置',
    facts: '基本信息',
    noPackage: '未绑定',
    navPerformance: '性能与缓存',
    navAnalytics: '分析和日志',
    siteId: '站点 ID',
    sectionTitle_overview: '站点概览',
    sectionDesc_overview: '站点的基本行为：HTTPS 强制跳转、SSL 模式、协议开关。改动会自动下发到所有节点。',
    sectionTitle_domains: '域名管理',
    sectionDesc_domains: '同一套配置下可以挂多个域名，它们共用源站、证书和全部防护规则。',
    'sectionTitle_cache-prefetch': '缓存预热',
    'sectionDesc_cache-prefetch': '提前把内容拉到各节点，让首次访问就命中缓存。支持即时执行和定时执行。',
    'sectionTitle_cache-jobs': '缓存刷新',
    'sectionDesc_cache-jobs': '让节点丢弃已缓存的内容，下次访问重新回源。任务会下发到所有节点。',
    sectionTitle_origins: '源站配置',
    sectionDesc_origins: '回源地址。配置多个时按权重轮询，备用源站仅在主源站不可用时启用。',
    sectionTitle_certificates: '证书管理',
    sectionDesc_certificates: '为站点签发或上传 HTTPS 证书。支持 Let\'s Encrypt 和 ZeroSSL 自动签发。',
    navBasics: '基础配置',
    navProtection: '防护配置',
    manage: '管理',
    detailTitle: '站点详情',
    backToList: '← 返回站点列表',
    syncStatusLabel: '同步状态',
    syncNow: '立即同步',
    syncState_never: '未同步',
    syncState_pending: '待同步',
    syncState_syncing: '同步中',
    syncState_synced: '已同步',
    syncState_failed: '同步失败',
    forceHttpsLabel: '强制 HTTPS',
    forceHttpsHint: '开启后，HTTP 访问会自动 301 跳转到 HTTPS（证书申请的验证请求不受影响）',
    sectionOverview: '概览',
    sectionDomains: '域名',
    upstreamLimitTitle: '回源并发上限',
    upstreamLimitHelp: '每个节点同时向源站发起的请求数上限。超出的请求在边缘直接返回 503,不会转发。这是唯一不依赖任何过滤判断是否准确的防护——无论边缘挨多少打,源站同时看到的请求数都不会超过这个值。填 0 表示不限制。',
    upstreamLimitOff: '0 = 不限制',
    upstreamLimitOn: '当前:每节点最多 {n} 个并发回源,超出部分在边缘返回 503。',
    upstreamLimitOffHint: '当前不限制:边缘收到多少就转发多少,源站负载完全取决于攻击量。建议按源站实测能力设置。',
    sectionOrigins: '源站',
    sectionCertificates: '证书',
    aliases: '附加域名',
    aliasesHint: '一个站点下的所有域名共用同一份源站配置和规则。新加的域名把 CNAME 指向本站、验证通过后才会被加速。',
    aliasHostnameCol: '域名',
    aliasesEmpty: '暂无附加域名',
    aliasesPlaceholder: '例如 www.example.com',
    aliasAdd: '添加',
    aliasAddSuccess: '已添加',
    aliasAddFailed: '添加失败',
    cnameTargetCol: 'CNAME 目标',
    origins: '源站',
    protocolsLabel: '协议支持',
    realIpHeaderLabel: '真实 IP 请求头',
    originAddr: '源站地址',
    originHostHeader: '回源 Host',
    originHostHeaderPlaceholder: '回源 Host（留空用站点域名）',
    originSniPlaceholder: 'SNI（留空同回源 Host）',
    originTlsHint: 'HTTPS 回源时，只有 SSL 模式为「strict」才校验源站证书；其它模式不校验，源站可以用自签证书或 IP 证书。回源 Host 是发给源站的 Host 头，源站是虚拟主机或对象存储时填它自己的域名。',
    originsEmpty: '暂无源站',
    originAddSuccess: '源站已添加',
    originAddFailed: '添加源站失败',
    publishedToPlain: '已发布 {version}',
    saveFailed: '保存失败',
    saveSuccess: '已保存',
    deleteModalTitle: '删除站点',
    deleteModalContent: '确定删除站点「{name}」吗？此操作不可撤销。',
    deleteSuccess: '已删除',
    deleteFailed: '删除失败',
    loadFailed: '加载站点列表失败',
    emptyHint: '暂无站点',
    sectionAnalytics: '流量分析',
    sectionTitle_analytics: '流量分析',
    sectionDesc_analytics: '站点和它全部域名的带宽、请求、流量、拦截与缓存命中，以及访问排行。',
    notInPackage: '套餐不含',
    hostnameQuota: '套餐域名 {used} / {max}',
    apexQuota: '主域名 {used} / {max}',
    notInPackageTip: '当前套餐「{package}」不包含 {feature}：无法开启；已开启的不会生效，可以关闭。',
    hostnamesFull: '已达到套餐的域名上限（{max} 个）',
    pkgSites: '站点 {used}/{max}',
    pkgFull: '站点已满',
  },
  // What keeps a site from being served properly (SiteReadiness.vue,
  // utils/readiness.ts).
  readiness: {
    noOrigin: '还没有配置源站，所有访问都会返回 502「源站连接失败」。',
    noCert: '{hosts} 没有可用的证书，HTTPS 访问会直接失败，浏览器提示「不支持的协议」。',
    certMismatch: '{hosts} 的证书与域名不匹配，浏览器会提示连接不安全。',
    addOrigin: '添加源站',
    getCert: '申请证书',
    changeCert: '更换证书',
    nameSep: '、',
    andMore: '{names} 等 {total} 个域名',
    shortNoOrigin: '未配置源站',
    shortNoCert: '缺少证书',
    shortMismatch: '证书不匹配',
    aliasPending: '{hosts} 还没有通过 CNAME 验证，暂时不会被加速。',
    verifyAlias: '去验证',
    shortAliasPending: '别名待验证',
    listHint: '该站点还不能正常访问',
  },
  domainDetail: {
    back: '← 返回',
    overview: '概览',
    rules: '规则',
    origins: '源站',
    certificates: '证书',
    requests: '请求数',
    bandwidth: '流量',
    errors5xx: '5xx',
    cacheHitRate: '缓存命中率',
    requestsPerMin: '每分钟请求数',
    topUrls: '热门 URL (24h)',
    legendRequests: '请求',
    legendCacheHits: '缓存命中',
    legend5xx: '5xx',
    noDataInRange: '当前时间段无数据',
    emptyTopUrls: '暂无热门 URL',
    range1h: '近 1 小时',
    range24h: '近 24 小时',
    range7d: '近 7 天',
    domainNotFound: '未找到该域名',
    loadFailed: '加载失败',
    cnameCardTitle: 'CNAME 解析',
    cnameInstructions: '在你的域名 DNS 服务商处添加下面这条记录，访问就会经过加速节点：',
    cnameGenerating: '生成中…',
    cnameGeneratingHint: '你所在的套餐还没有配置 CNAME 域名，请联系管理员开通',
    cnameStatusActive: '已生效',
    cnameStatusPending: '待验证',
    cnameVerifyButton: '验证解析',
    cnameVerifySuccess: '验证成功，域名已生效',
    cnameVerifyMismatch: '还未查询到匹配的 CNAME 解析，请确认已正确配置并等待生效',
    cnameVerifyFailed: '验证失败',
    aliasesCardTitle: '站点域名',
    aliasesHint: '一个站点下的所有域名共用同一份源站配置和规则。新加的域名把 CNAME 指向本站、验证通过后才会被加速。',
    aliasesPlaceholder: '例如 www.example.com',
    aliasAdd: '添加',
    aliasAddSuccess: '已添加',
    aliasAddFailed: '添加失败',
    uriCol: 'URI',
    bytesCol: '流量',
    avgRt: '平均响应',
    p95Rt: 'P95 响应',
    addOrigin: '添加源站',
    issueCert: '申请证书',
    acmeEmail: '邮箱',
    acmeStaging: 'ACME 演练环境',
    acmeAgree: '同意 Let’s Encrypt TOS',
    recordType: '记录类型',
    recordHost: '主机记录',
    recordValue: '记录值',
    cnameAliasHint: '附加域名也要 CNAME 到同一个地址，验证通过后才会被加速；各域名的验证状态在「域名」里。',
  },
  rules: {
    customRules: '自定义规则',
    ruleCount: '共 {n} 条',
    kindDesc_acl: '按 IP、网段、地区、ASN、User-Agent、TLS 指纹等条件放行或拦截请求。白名单优先于其他所有规则。',
    kindDesc_geo: '按访客所在的国家或地区拦截、验证或放行。在其它防护规则之前执行。',
    kindDesc_cc: '按访问频率限流。同一来源在时间窗口内超过阈值时，可以限速、拦截、弹人机校验或临时封禁。',
    kindDesc_waf: '匹配 SQL 注入、XSS、命令执行等攻击特征。命中后累加分值，超过站点阈值才拦截，避免单条误判直接影响业务。',
    kindDesc_bot: '识别伪造搜索引擎的爬虫和已知扫描器。真实蜘蛛通过反向 DNS 校验放行。',
    kindDesc_cache: '按后缀、目录、路径或状态码匹配，设置节点缓存多久、是否强制缓存。',
    backToDomain: '返回站点',
    title: '规则',
    backToDomains: '← 返回站点列表',
    pageTitle: '站点 #{id} — 规则',
    selectKind: '选择规则类型',
    kindAcl: '访问控制（ACL）',
    kindGeo: '区域屏蔽',
    kindWaf: 'WAF',
    kindCc: 'CC 防护',
    kindBot: '机器人',
    kindCache: '缓存配置',
    add: '新增规则',
    publish: '发布',
    priority: '优先级',
    priorityHint: '数字越小，优先级越高，越先匹配。',
    enabledHint: '规则已启用，下次发布时会生效。',
    disabledHint: '规则已保存但不会生效。',
    action: '动作',
    typeCol: '类型',
    categoryCol: '类别',
    statusCol: '状态',
    addModalTitle: '新建{kind}规则',
    editModalTitle: '编辑{kind}规则',
    deleteModalTitle: '删除规则？',
    deleteModalContent: '规则 #{id}（{name}）将被删除。需重新发布域名才会在边缘生效。',
    deleteConfirm: '确定删除这条规则？',
    deleteSuccess: '已删除',
    deleteFailed: '删除失败',
    addSuccess: '规则已添加',
    addFailed: '添加失败',
    updateSuccess: '规则已更新',
    validationFailed: '请检查标红的字段',
    loadFailed: '加载规则失败',
    invalidJson: 'JSON 格式错误',
    publishedTo: '已发布 {version}，下发到 {n} 个节点',
    publishedToPlain: '已发布 {version}',
    publishFailed: '发布失败',
    emptyHint: '暂无规则，点「新增规则」开始添加。',
    actions: {
      allow: '放行',
      log: '仅记录',
      rate_limit429: '限速（429）',
      challenge_js: 'JS 验证',
      challenge_slider: '滑块验证',
      challenge_click: '点击验证',
      deny403: '拦截（403）',
      deny444: '拦截（444，静默丢弃）',
      ban: '封禁 IP',
      deny: '拒绝（自定义状态码）',
      ban_kernel: '内核级封禁',
    },
    acl: {
      matchCol: '匹配条件',
      namePlaceholder: '例如 block-known-scanners',
      types: {
        ip: 'IP 地址',
        cidr: 'IP 段（CIDR）',
        geo: '国家/地区',
        asn: 'ASN',
        ua: 'User-Agent',
        referer: 'Referer',
        header: '请求头',
        ja4: 'JA4 指纹',
        ja3: 'JA3 指纹',
      },
      matchValues: '值',
      matchCountries: '国家/地区代码',
      matchAsn: 'ASN 编号',
      matchContains: '包含（不区分大小写）',
      headerName: '请求头名称',
      placeholderIp: '例如 203.0.113.7，回车添加',
      placeholderCidr: '例如 203.0.113.0/24，回车添加',
      placeholderCountry: '例如 CN、US，回车添加',
      placeholderAsn: '例如 13335，回车添加',
      placeholderSubstring: '例如 curl/，回车添加',
      placeholderJa4: '例如 t13d1516h2_8daaf6152771_02713d6af862，回车添加',
      placeholderJa3: '例如 773906b0efdefa24a7f2b8eb6985bf37，回车添加',
      fingerprintHint: 'TLS 客户端指纹，按访问日志里显示的值精确匹配（不区分大小写）；明文 HTTP 请求没有指纹，不会命中。',
    },
    cc: {
      namePlaceholder: '例如 login-bruteforce',
      matchTitle: '匹配条件',
      methods: '请求方法',
      methodsPlaceholder: '不限',
      path: '请求路径',
      pathPlaceholder: '不填则匹配全部路径，例如 /api/login',
      pathModes: { prefix: '前缀匹配', exact: '精确匹配', contains: '包含' },
      countStatus: '按响应状态码计数',
      countStatusPlaceholder: '例如 401,403 或 5xx，留空则所有请求都计数',
      countStatusHint: '只统计响应为这些状态码的请求。防撞库填 401,403；防刷不存在的页面填 404。',
      countTitle: '统计方式',
      dimensions: '统计维度',
      dimensionsHint: '按这些维度分组计数，最多 3 个。例如 IP + 请求路径会对每个访客的每个接口分别计数；按请求头可以给每个 API Key 单独限额。',
      fingerprintHint: '同一版本的浏览器 TLS 指纹相同，只按指纹统计会把这些访客都算作一个，适合限制自带指纹的脚本和工具，或与请求路径一起用。明文 HTTP 请求没有指纹，会合并计数。Chrome 每次连接都会打乱 JA3，优先用 JA4。',
      dims: {
        ip: '客户端 IP',
        uri: '请求路径',
        ua: 'User-Agent',
        host: '访问域名',
        ja4: 'TLS 指纹（JA4）',
        ja3: 'TLS 指纹（JA3）',
        country: '国家/地区',
        header: '请求头',
        cookie: 'Cookie',
      },
      dimNamePlaceholder_header: '请求头名称，如 X-Api-Key',
      dimNamePlaceholder_cookie: 'Cookie 名称，如 session_id',
      addDimension: '+ 添加维度',
      windowSeconds: '统计周期（秒）',
      threshold: '请求数阈值',
      thresholdCol: '阈值/周期',
      matchCol: '匹配条件',
      anyRequest: '全部请求',
      statusOnly: '仅计 {status}',
      actionTitle: '处置',
      statusCode: '响应状态码',
      mitigation: '处置方式',
      mitigations: { throttle: '限流', penalty: '惩罚' },
      mitigationHint_throttle: '只处置超出阈值的那部分请求，频率降下来就恢复正常。',
      mitigationHint_penalty: '一旦触发，该来源在持续时间内的所有请求都按上面的动作处置。',
      ttlSeconds: '持续时间（秒）',
      ttlHint: '验证通过后的免验证时长，或封禁、惩罚的持续时长。',
      escalationTitle: '阶梯处置（可选）',
      addTier: '+ 添加一级',
      escalationHint: '同一来源反复触发时，按累计次数升级为更严厉的动作，最多 5 级。',
      escalationEmpty: '未配置，每次触发都按上面的动作处置。',
      afterViolations: '累计触发',
      thenAction: '次后升级为',
      forSeconds: '持续（秒）',
    },
    waf: {
      namePlaceholder: '例如 block-sqlmap-signature',
      categories: {
        sqli: 'SQL 注入',
        xss: '跨站脚本（XSS）',
        rce: '远程代码执行',
        traversal: '路径穿越',
        scanner: '扫描器/探测',
        webshell: 'Webshell',
        custom: '自定义',
      },
      targets: '检测位置',
      targetsCol: '检测位置',
      targetsPlaceholder: '可多选',
      targetLabels: { uri: 'URL 路径', args: '查询字符串', cookie: 'Cookie 头', method: 'HTTP 方法' },
      alsoInspectHeader: '同时检测指定请求头',
      pattern: '匹配规则（正则）',
      patternHint: '对所有选中的检测位置做不区分大小写的匹配。',
      score: '分值',
      scoreHint: '命中后累加到该域名的总分——总分达到 WAF 阈值时才会真正拦截。',
    },
    bot: {
      namePlaceholder: '例如 block-scraping-tool',
      matchMode: '匹配方式',
      modeSimple: '包含（简单）',
      modeAdvanced: '正则（高级）',
      uaContains: 'User-Agent 包含',
      uaContainsHint: '不区分大小写的子串匹配，不需要正则语法。',
      uaRegex: 'User-Agent 正则',
      uaRegexHint: '完整正则表达式，不区分大小写匹配。',
      patternCol: '匹配内容',
    },
    cache: {
      matchCol: '匹配条件',
      matchSuffix: '文件后缀',
      matchDir: '路径前缀',
      matchUri: '精确路径',
      matchStatus: '状态码',
      ttlSeconds: 'TTL（秒）',
      forceCache: '强制缓存（忽略源站缓存头）',
      bypassCookies: '按 Cookie 名称绕过缓存',
      varyQuery: '按查询参数区分缓存',
    },
    notInPackage_waf: '当前套餐「{package}」不包含 WAF：这个站点不执行任何 WAF 规则（包括平台内置规则），也不能新增或修改。换到含 WAF 的套餐后，下面的规则自动恢复生效。',
    notInPackageOps_waf: '该站点的套餐「{package}」不包含 WAF：节点不执行它的任何 WAF 规则（包括平台内置规则）。下面的规则会保留，站点换到含 WAF 的套餐后自动生效。',
    notInPackage_cc: '当前套餐「{package}」不包含自定义 CC 规则：上面的防护等级和强制验证照常生效；下面的规则不会生效，也不能新增或修改。',
    notInPackageOps_cc: '该站点的套餐「{package}」不包含自定义 CC 规则：下面的规则保留但不会生效，防护等级和强制验证照常。',
    notInPackageShort: '当前套餐不包含此功能',
    quotaUsed: '本站规则 {used} / {max}',
    quotaFull: '已达到套餐的规则上限：每个站点最多 {max} 条',
  },
  errors: {
    network: '网络错误',
    unknown: '未知错误',
    notFound: '未找到',
    forbidden: '权限不足',
  },
  // ---- M5.1 证书管理 ------------------------------------------------------
  certificates: {
    title: '证书管理',
    sectionTitle: '证书管理',
    domain: '所属域名',
    typeUpload: '上传',
    typeAcme: 'ACME',
    commonNameCol: '主域名',
    issuerCol: '签发者',
    notBeforeCol: '生效',
    notAfterCol: '过期',
    statusCol: '状态',
    fingerprintCol: '指纹',
    expiringDays: '{n} 天后过期',
    expired: '已过期',
    issueAcme: '通过 ACME 申请',
    refresh: '刷新',
    empty: '该域名暂无证书',
    aboutExpire: '即将过期',
    stateCancelled: '已取消',
    attachTitle: '使用已有证书',
    issueCancelled: '已取消',
    issueRetryNow: '立即重试',
    uploadMoved: '上传证书请到证书管理页面：',
    attachSuccess: '已应用到本站点',
    attachPlaceholder: '从已有证书中选择',
    attach: '使用这张证书',
    pemRequired: '请填写证书和私钥',
    siteRequired: '请选择站点',
    sitePlaceholder: '选择站点',
    siteHint: '证书会绑定到这个站点并下发到节点。同一张证书可以在站点详情里改绑到别的站点。',
    siteLabel: '应用到站点',
    noSite: '未绑定',
    siteCol: '所属站点',
    emailHint: '用于向证书颁发机构注册账号和接收到期提醒。申请即代表接受该机构的服务条款。',
    stateNextRun: '下次重试：{t}',
    stateFailed: '签发失败',
    stateSuccess: '证书已签发',
    statePending: '正在签发…（第 {n}/{max} 次尝试）',
    issueRetry: '重新申请',
    issueQueueHint: '签发在后台队列里执行，可以离开这个页面。失败原因会显示在上方，管理员也能在「任务队列 → 系统任务」看到每次尝试的详细报错。',
    issueQueued: '已加入签发队列，结果会显示在上面',
    emailLabel: '邮箱',
    emailRequired: '请填写邮箱',
    caLabel: '证书颁发机构',
    issueFailed: '证书签发失败',
    uploadCert: '上传证书',
    uploadSuccess: '证书已上传',
    uploadFailed: '上传证书失败',
    statTotal: '证书总数',
    statValid: '有效',
    statExpiring: '即将到期',
    statExpiringNote: '{n} 天内',
    statExpired: '已过期',
    statRevoked: '{n} 张已吊销',
    listTitle: '全部证书',
    listCount: '共 {n} 张',
    listFiltered: '筛选后 {n} 张',
    searchPlaceholder: '搜索证书域名或颁发机构',
    filterAllSites: '全部站点',
    filterAllTypes: '全部类型',
    filterAllStatus: '全部状态',
    state_valid: '有效',
    state_expiring: '即将到期',
    state_expired: '已过期',
    state_revoked: '已吊销',
    certCol: '证书',
    moreNames: '+{n} 个域名',
    typeCol: '类型',
    expiresCol: '到期时间',
    emptyHint: '还没有证书。在站点的 SSL 页面可以申请免费证书，也可以在这里上传。',
    certPem: '证书（PEM）',
    certPemHint: '先粘服务器证书，再粘中间证书：整条证书链一起。',
    keyPem: '私钥（PEM）',
    keyPemHint: '私钥加密保存，只用于节点上的 HTTPS 握手。',
    uploadsNotInPackage: '您的套餐都不支持上传证书，可以在站点里申请免费证书',
  },
  // ---- M7.2 API 凭证 (AK/SK) ---------------------------------------------
  billing: {
    title: '充值中心',
    statBalance: '账户余额',
    statPaid: '累计充值',
    statPending: '待支付订单',
    unitYuan: '元',
    unitOrders: '笔',
    closed: '在线充值暂未开放，如需充值请联系管理员',
    amount: '充值金额',
    otherAmount: '其他金额',
    customPlaceholder: '输入充值金额',
    customRequired: '请填写充值金额',
    outOfRange: '超出单笔充值金额范围',
    range: '单笔 ¥{min} – ¥{max}',
    method: '支付方式',
    choice_alipay: '支付宝',
    choiceSub_alipay: '跳转至支付宝完成付款',
    choice_qr: '支付宝扫码',
    choiceSub_qr: '用手机支付宝扫一扫付款',
    due: '应付金额',
    pay: '立即充值',
    intro: '付款成功后余额即时到账。如付款后余额没有变化，可在充值记录中点击「查询结果」，或联系我们并提供订单号。',
    listCount: '共 {n} 条',
    noOrders: '还没有充值记录',
    noLedger: '还没有收支记录',
    state_pending: '待支付',
    state_paid: '已支付',
    state_closed: '已关闭',
    state_expired: '已过期',
    method_page: '支付宝 · 电脑网站',
    method_wap: '支付宝 · 手机网站',
    method_qr: '支付宝 · 扫码',
    ask: '查询结果',
    askPaid: '已确认付款，¥{amount} 已到账',
    askUnpaid: '支付宝暂未收到这笔订单的付款',
    balanceAfter: '余额 ¥{amount}',
    colOrderNo: '订单号',
    colAmount: '充值金额',
    colMethod: '支付方式',
    colCreated: '创建时间',
    colPaid: '支付时间',
    colTime: '时间',
    colKind: '类型',
    colChange: '金额',
    colBalance: '余额',
    colNote: '说明',
    qrTitle: '扫码支付',
    qrHint: '打开支付宝 App，扫一扫付款',
    qrLeft: '剩余支付时间',
    qrOpen: '打开支付宝付款',
    paidTitle: '充值成功',
    paidSub: '¥{amount} 已存入账户余额',
    done: '完成',
    close: '关闭',
    expiredTitle: '订单已过期',
    expiredSub: '这笔订单已超过支付时限，请重新发起充值',
    returnTitle: '支付结果',
    checking: '正在向支付宝确认支付结果…',
    closedTitle: '订单已关闭',
    closedSub: '这笔订单没有完成支付，请重新发起充值',
    unconfirmedTitle: '暂未确认到付款',
    unconfirmedSub: '如果您已完成付款，余额通常会在几分钟内到账，也可以稍后在充值记录中查询结果',
    checkAgain: '再次查询',
    statRemits: '待确认汇款',
    tabOnline: '在线充值',
    tabOrders: '充值记录',
    tabRemit: '线下汇款',
    tabRemits: '汇款记录',
    remitClosed: '暂不支持线下汇款，如需对公转账请联系管理员',
    remitTo: '收款账户',
    acctName: '户名',
    acctBank: '开户行',
    acctNo: '账号',
    acctNote: '说明',
    remitAmount: '汇款金额',
    remitAmountPlaceholder: '与银行回单一致，不低于 ¥{min}',
    remitAmountRequired: '请填写汇款金额',
    remitAmountMin: '汇款金额不能低于 ¥{min}',
    payer: '汇款户名',
    payerPlaceholder: '与银行回单上的付款户名一致',
    payerAccount: '汇款账号',
    optional: '选填',
    remitDate: '汇款日期',
    reference: '流水号',
    referencePlaceholder: '选填，银行回单上的交易流水号',
    receipt: '汇款凭证',
    receiptHint: '银行回单截图或 PDF，不超过 5 MB',
    receiptTooLarge: '凭证文件不能超过 5 MB',
    remitNote: '备注',
    remitNotePlaceholder: '选填，例如款项用途',
    remitSubmit: '提交汇款信息',
    remitIntro: '请先通过网银或柜台汇款到上方收款账户，再上传银行回单提交。财务核对到账后，汇款金额会存入账户余额，通常在 1 个工作日内完成。',
    remitted: '汇款信息已提交，等待财务确认',
    noRemits: '还没有汇款记录',
    rejectedFor: '未通过：{note}',
    viewReceipt: '查看凭证',
    cancel: '撤销',
    cancelRemitTitle: '撤销这笔汇款申请？',
    cancelRemitContent: '撤销后财务将不再核对这笔 ¥{amount} 的汇款。如果钱已汇出，请重新提交汇款信息。',
    cancelled: '已撤销',
    colRemitNo: '汇款单号',
    colRemitTo: '收款账户',
    colRemitDate: '汇款日期',
    colSubmitted: '提交时间',
  },
  // 财务管理: 收支明细, 订单管理, 提现, 发票, 退款, and buying a package.
  ledger: {
    kind_realname: '实名认证',
    kind_realname_back: '实名认证退回',
    title: '收支明细',
    statBalance: '账户余额',
    statPaid: '累计充值',
    statSpent: '累计消费',
    statOut: '提现及退款',
    listTitle: '全部收支',
    allKinds: '全部类型',
    group_topup: '充值',
    group_purchase: '消费',
    group_refund: '退款',
    group_withdraw: '提现',
    group_adjust: '余额调整',
    clear: '清除筛选',
    noMatch: '没有符合条件的记录',
    colDoc: '关联单号',
    kind_topup: '在线充值',
    kind_remittance: '线下汇款',
    kind_adjust: '余额调整',
    kind_purchase: '套餐消费',
    kind_order_refund: '套餐退款',
    kind_withdraw: '提现',
    kind_withdraw_back: '提现退回',
    kind_refund: '充值退款',
    kind_refund_back: '退款退回',
    desc_topup: '支付宝在线充值',
    desc_remittance: '银行汇款，财务确认入账',
    desc_purchase: '套餐「{name}」',
    desc_order_refund: '套餐「{name}」退款至余额',
    desc_withdraw: '提现至支付宝，申请时从余额扣除',
    desc_withdraw_back: '提现未完成，金额退回余额',
    desc_refund: '原路退回支付宝，申请时从余额扣除',
    desc_refund_back: '退款未完成，金额退回余额',
  },
  orders: {
    title: '订单管理',
    statOrders: '套餐订单',
    statSubs: '生效套餐',
    listTitle: '套餐订单',
    count: '共 {n} 笔',
    buy: '购买套餐',
    empty: '还没有套餐订单',
    colOrderNo: '订单号',
    colPackage: '套餐',
    colPeriod: '时长',
    colAmount: '金额',
    colSpan: '服务期',
    colCreated: '下单时间',
    kind_buy: '新购',
    kind_renew: '续费',
    state_paid: '已支付',
    state_partly_refunded: '部分退款',
    state_refunded: '已退款',
    refunded: '已退款 ¥{amount}',
    askRefund: '申请退款',
  },
  withdraw: {
    title: '提现管理',
    statCashable: '可提现金额',
    statWithdrawn: '累计提现',
    statPending: '处理中',
    statAccounts: '提现账户',
    unitAccounts: '个',
    tabApply: '申请提现',
    tabAccounts: '提现账户',
    tabRecords: '提现记录',
    closed: '暂不支持提现，如需提现请联系管理员',
    notReady: '提现服务暂未就绪，暂时无法提交申请，请稍后再试或联系管理员',
    cashable: '可提现金额',
    invoicedNote: '已开票的 ¥{amount} 不可提现',
    toAccount: '提现到',
    accountRequired: '请选择提现账户',
    noAccountYet: '请先添加提现账户',
    addAccount: '添加提现账户',
    amount: '提现金额',
    amountPlaceholder: '不低于 ¥{min}',
    amountRequired: '请填写提现金额',
    outOfRange: '超出单笔提现金额范围',
    takeAll: '全部提现',
    range: '单笔 ¥{min} – ¥{max}',
    overCashable: '最多可提现 ¥{max}',
    fee: '手续费',
    feeFree: '免手续费',
    feeRate: '按提现金额的 {rate}% 收取',
    feeFixed: '每笔 ¥{min}',
    feeRateMin: '按提现金额的 {rate}% 收取，最低 ¥{min}',
    net: '实际到账',
    submit: '申请提现',
    applied: '提现申请已提交，等待审核',
    intro: '提现申请提交后，金额立即从余额中扣除；审核通过后转入你的支付宝账户，通常在 1–3 个工作日内完成。申请被驳回或撤销时，金额退回余额。已开具发票的金额不能提现。',
    accountsNote: '已添加 {n} 个，最多 {max} 个',
    noAccounts: '还没有提现账户',
    accountsIntro: '提现只能转入实名认证的支付宝账户，真实姓名需与支付宝实名一致，否则转账会失败。删除账户不影响已提交的提现。',
    colRealName: '真实姓名',
    colAccount: '支付宝账号',
    colLabel: '备注',
    colAdded: '添加时间',
    deleteTitle: '删除提现账户？',
    deleteContent: '删除后不能再提现到 {account}，已提交的提现不受影响。',
    accountAdded: '提现账户已添加',
    realName: '真实姓名',
    realNamePlaceholder: '支付宝实名认证的姓名',
    realNameHelp: '需与支付宝实名一致，否则转账会失败',
    alipayAccount: '支付宝账号',
    alipayAccountPlaceholder: '邮箱或手机号',
    accountLabel: '备注',
    accountLabelPlaceholder: '选填，例如「公司账户」',
    noRecords: '还没有提现记录',
    colNo: '提现单号',
    colAmount: '提现金额',
    colFee: '手续费',
    colNet: '到账金额',
    colTo: '收款账户',
    colApplied: '申请时间',
    feeNet: '手续费 ¥{fee}，到账 ¥{net}',
    rejectedFor: '已驳回：{note}',
    failedFor: '支付宝转账未成功：{reason}，平台正在处理',
    cancel: '撤销',
    cancelTitle: '撤销这笔提现？',
    cancelContent: '撤销后 ¥{amount} 将退回账户余额。',
    cancelled: '已撤销，金额已退回余额',
  },
  invoice: {
    title: '发票管理',
    statOpen: '可开票金额',
    statDone: '累计开票',
    statPending: '待开票',
    statTitles: '发票抬头',
    unitInvoices: '张',
    unitTitles: '个',
    tabApply: '发票申请',
    tabRecords: '发票记录',
    tabProfiles: '发票信息',
    closed: '暂不支持在线申请发票，如需开票请联系管理员',
    open: '可开票金额',
    openNote: '按实付金额开具：充值和汇款入账，扣除已退款、已提现和已开票的部分',
    type: '发票类型',
    typeLong_normal: '增值税普通发票',
    typeLong_special: '增值税专用发票',
    type_normal: '普票',
    type_special: '专票',
    medium: '开票方式',
    medium_electronic: '电子发票',
    medium_paper: '纸质发票',
    header: '发票抬头',
    headerPlaceholder: '选择发票抬头',
    headerCompany: '企业全称，与营业执照一致',
    headerPersonal: '个人姓名',
    kind: '抬头类型',
    kind_company: '企业',
    kind_personal: '个人',
    taxNoShort: '税号',
    personalLine: '个人抬头',
    addProfile: '新增发票抬头',
    editProfile: '编辑发票抬头',
    amount: '开票金额',
    amountPlaceholder: '不低于 ¥{min}',
    amountRequired: '请填写开票金额',
    amountHint: '单张发票不低于 ¥{min}',
    takeAll: '全部开票',
    submit: '提交申请',
    applied: '发票申请已提交',
    intro: '发票按实付金额开具，开票后的金额不能再提现或退款。电子发票开具后可在发票记录中下载；纸质发票通过快递寄出，快递单号可在发票记录中查看。',
    noRecords: '还没有发票记录',
    colNo: '申请单号',
    colTitle: '发票抬头',
    colKind: '发票类型',
    colAmount: '金额',
    colNumber: '发票号码',
    colApplied: '申请时间',
    numberIs: '发票号码 {number}',
    expressIs: '快递 {express}',
    download: '下载发票',
    express: '物流信息',
    details: '详情',
    detailTitle: '发票详情',
    issuedAt: '开票时间',
    reviewedAt: '处理时间',
    cancelApply: '撤销申请',
    cancel: '撤销',
    cancelTitle: '撤销这张发票申请？',
    cancelContent: '撤销后 ¥{amount} 恢复为可开票金额。',
    cancelled: '已撤销',
    profilesNote: '已添加 {n} 个，最多 {max} 个',
    noProfiles: '还没有发票抬头',
    isDefault: '默认',
    makeDefault: '设为默认',
    defaultSet: '已设为默认抬头',
    taxNo: '纳税人识别号',
    taxNoPlaceholder: '15–20 位数字或大写字母',
    registered: '注册信息',
    bankShort: '开户信息',
    email: '接收邮箱',
    emailHelp: '电子发票发送到这个邮箱',
    mailTo: '邮寄信息',
    specialSection: '开具专用发票需要填写',
    address: '注册地址',
    phone: '注册电话',
    bank: '开户银行',
    bankAccount: '银行账号',
    deliverySection: '发票接收',
    recipient: '收件人',
    recipientPhone: '联系电话',
    mailAddress: '邮寄地址',
    setDefault: '设为默认抬头',
    profileSaved: '发票抬头已保存',
    deleteTitle: '删除发票抬头？',
    deleteContent: '删除「{title}」后，已提交的发票申请不受影响。',
  },
  refund: {
    title: '退款管理',
    statRefunded: '累计退款',
    statOpen: '可退款订单',
    statPending: '处理中',
    tabApply: '退款申请',
    tabRecords: '退款记录',
    closed: '暂不支持在线申请退款，如需退款请联系管理员',
    termsTitle: '退款规则',
    termsTopUp: '充值订单在支付后 {n} 天内可申请退款，原路退回付款的支付宝账户，退款金额在申请时从余额中扣除。',
    termsPackage: '套餐订单在购买后 {n} 天内可申请退款，退回账户余额，并扣减该订单购买的套餐时长。',
    termsInvoiced: '已开具发票的金额不能退款。',
    noOpen: '当前没有可申请退款的订单',
    target_topup: '充值',
    target_package: '套餐',
    topUpTitle: '支付宝充值',
    colTarget: '订单类型',
    colOrderNo: '订单号',
    colWhat: '内容',
    colPaid: '订单金额',
    colMax: '可退金额',
    colPaidAt: '支付时间',
    colDeadline: '退款截止',
    ask: '申请退款',
    askTitle: '申请退款',
    maxIs: '最多可退 ¥{amount}',
    deadlineIs: '{date} 前可退',
    amount: '退款金额',
    reason: '退款原因',
    reasonPlaceholder: '请说明退款原因，便于我们改进',
    whereTopUp: '退款将原路退回付款的支付宝账户，申请提交后金额先从余额中扣除；审核未通过或撤销时退回余额。',
    wherePackage: '退款将退回账户余额，并扣减该订单购买的套餐时长，套餐可能因此提前到期。',
    submit: '提交申请',
    applied: '退款申请已提交，等待审核',
    noRecords: '还没有退款记录',
    colNo: '退款单号',
    colOrder: '原订单',
    colAmount: '退款金额',
    colReason: '退款原因',
    colApplied: '申请时间',
    failedFor: '支付宝退款未成功：{reason}，平台正在处理',
    partly: '申请 ¥{asked}，实退 ¥{paid}',
    cancel: '撤销',
    cancelTitle: '撤销这笔退款申请？',
    cancelContent: '撤销后将不再退款 ¥{amount}。',
    cancelContentTopUp: '撤销后 ¥{amount} 将退回账户余额。',
    cancelled: '已撤销',
  },
  // 购买套餐, and paying for a package (CheckoutModal).
  store: {
    title: '购买套餐',
    listTitle: '选择套餐',
    count: '共 {n} 个',
    period_month: '月付',
    period_quarter: '季付',
    period_year: '年付',
    per_month: '/月',
    per_quarter: '/季',
    per_year: '/年',
    months_month: '1 个月',
    months_quarter: '3 个月',
    months_year: '1 年',
    noPeriod: '暂不支持{period}',
    save: '比月付省 ¥{amount}',
    perMonth: '折合 ¥{amount}/月',
    unlimited: '不限',
    allGroups: '全部',
    ungrouped: '其他',
    held: '已拥有',
    heldOne: '你已拥有这个套餐，{date} 到期',
    heldMany: '你已拥有 {n} 份这个套餐',
    specTitle: '规格',
    featureTitle: '功能',
    spec_traffic: '每月流量',
    spec_requests: '每月请求数',
    spec_bandwidth: '带宽上限',
    spec_connections: '并发连接数',
    spec_sites: '站点数',
    spec_hostnames: '域名数',
    spec_apexes: '主域名数',
    spec_rules: '每站点规则数',
    spec_l4: '应用加速规则',
    spec_cc: 'CC 防护',
    spec_ddos: 'DDoS 防护',
    spec_logs: '日志保存',
    v_requests: '{n}次',
    v_count: '{n} 个',
    v_rules: '{n} 条',
    v_days: '{n} 天',
    h_traffic: '每月 {n} 流量',
    h_trafficAll: '流量不限',
    h_bandwidth: '{n} 带宽',
    h_bandwidthAll: '带宽不限',
    h_sites: '{n} 个站点',
    h_sitesAll: '站点数不限',
    compareTitle: '套餐对比',
    compareCol: '规格与功能',
    included: '包含',
    excluded: '不包含',
    renew: '续费',
    buy: '立即购买',
    balanceLine: '套餐使用账户余额支付，当前余额 ¥{amount}',
    topUp: '去充值',
    closedTitle: '暂未开放在线购买',
    closedSub: '如需购买或升级套餐，请提交工单联系我们。',
    contact: '提交工单',
    toMine: '查看我的套餐',
    nothingOnSale: '暂无可购买的套餐',
    buyTitle: '购买套餐',
    renewTitle: '续费套餐',
    coPackage: '套餐',
    coPeriod: '购买时长',
    coTerm: '服务期',
    coBalance: '账户余额',
    coDue: '应付金额',
    termValue: '{start} 至 {end}',
    noPrice: '这个套餐暂未定价，请联系客服',
    pay: '确认支付 ¥{amount}',
    payPlain: '确认支付',
    short: '余额不足，还差 ¥{amount}',
    afterPay: '支付后余额 ¥{amount}',
    renewed: '「{name}」已续费',
    doneTitle: '购买成功',
    doneSub: '「{name}」已生效，有效期至 {date}',
    doneOrder: '订单号 {no}',
    toSites: '去添加站点',
  },
  finance: {
    state: {
      remit: {
        pending: '待确认',
        approved: '已入账',
        rejected: '未通过',
        cancelled: '已撤销',
      },
      withdraw: {
        pending: '待审核',
        processing: '打款中',
        success: '已到账',
        failed: '打款异常',
        rejected: '已驳回',
        cancelled: '已撤销',
      },
      invoice: {
        pending: '待开票',
        issued: '已开票',
        rejected: '已驳回',
        cancelled: '已撤销',
      },
      refund: {
        pending: '待审核',
        processing: '退款中',
        success: '已退款',
        failed: '退款异常',
        rejected: '已驳回',
        cancelled: '已撤销',
      },
    },
  },
  // 工单中心.
  tickets: {
    confidential: '保密发送',
    confidentialHelp: '用于发送密码、密钥等敏感信息：消息默认打码显示，不会出现在邮件和站内信里；工单关闭时内容和附件会被销毁。',
    title: '我的工单',
    newTitle: '提交工单',
    detailTitle: '工单详情',
    unit: '个',
    statAll: '全部工单',
    statActive: '处理中',
    statReplied: '待我回复',
    statClosed: '已关闭',
    listTitle: '工单列表',
    listCount: '共 {n} 个',
    searchPlaceholder: '搜索问题描述或工单编号',
    filterAll: '全部状态',
    filter_active: '处理中',
    filter_replied: '待我回复',
    filter_closed: '已关闭',
    resetFilters: '重置筛选',
    empty: '还没有提交过工单',
    noMatch: '没有符合条件的工单',
    unread: '新回复',
    colNo: '工单编号',
    colTitle: '问题描述',
    colCategory: '问题分类',
    colPriority: '优先级',
    colUpdated: '最近更新',
    view: '查看',
    close: '关闭',
    closeTicket: '关闭工单',
    closeTitle: '关闭工单',
    closeContent: '确定关闭工单「{title}」吗？关闭后不能再回复，如有新问题需要重新提交工单。',
    closed: '工单已关闭',
    updatedAt: '{time} 更新',
    status_open: '待处理',
    status_processing: '处理中',
    status_replied: '待我回复',
    status_closed: '已关闭',
    priority_normal: '一般',
    priority_high: '较高',
    priority_urgent: '紧急',
    priorityHint_normal: '咨询或配置问题，不影响使用',
    priorityHint_high: '部分功能异常，业务受到影响',
    priorityHint_urgent: '服务中断，业务无法访问',
    category: '问题分类',
    categoryPlaceholder: '选择问题分类',
    priority: '优先级',
    site: '相关站点',
    sitePlaceholder: '选择问题涉及的站点（选填）',
    bodyHelp: '一个工单只描述一个问题。写明涉及的网址、出现时间和报错信息，能更快定位问题；请勿填写密码、密钥等敏感信息',
    files: '附件',
    body: '问题描述',
    bodyPlaceholder: '请尽量详细地描述：问题现象、出现时间、涉及的网址、报错信息，以及已经尝试过的操作。截图可以直接粘贴进来。',
    bodyRequired: '请描述你遇到的问题',
    submit: '提交工单',
    filed: '工单已提交，客服会尽快处理',
    closedForNew: '暂不支持在线提交工单',
    closedForNewSub: '如需帮助，请通过其他方式联系客服。已提交的工单仍可在「我的工单」中查看和回复。',
    toList: '返回工单列表',
    filedAt: '提交时间',
    repliedTip: '{support}已回复。问题已解决的话，可以关闭工单；长时间未回复，工单会自动关闭。',
    replyPlaceholder: '请输入您的问题，图片支持粘贴及拖拽。工程师将根据您的留言尽快处理，退出页面工单不会被关闭。',
    send: '发送',
    replied: '回复已发送',
    missing: '工单不存在',
    missingSub: '工单可能已被删除，或者不属于当前账号。',
    rateTitle: '服务评价',
    closedBy_customer: '你已于 {time} 关闭工单',
    closedBy_staff: '{support}已于 {time} 关闭工单',
    closedBy_auto: '工单因长时间未回复，已于 {time} 自动关闭',
    rateAsk: '你对本次服务满意吗？',
    ratePick: '点击星星评分',
    commentPlaceholder: '说说你的感受（选填）',
    rateSubmit: '提交评价',
    rated: '感谢你的评价',
    ratedAt: '评价于 {time}',
    stars_1: '很不满意',
    stars_2: '不满意',
    stars_3: '一般',
    stars_4: '满意',
    stars_5: '非常满意',
    infoTitle: '相关信息',
    account: '提交账号',
    contactEmail: '联系邮箱',
    reveal: '显示',
    conceal: '隐藏',
    stepFiled: '提交工单',
    stepAccepted: '客服受理',
    stepResolved: '问题解决',
    stepRated: '服务评价',
    stepWaiting: '等待受理',
    stepHandling: '处理中',
    stepReplied: '客服已回复',
    stepToRate: '待评价',
  },
  // ---- 我的投诉 ----
  l4: {
    title: '加速规则',
    unit: '条',
    statAll: '全部规则',
    statActive: '运行中',
    statDisabled: '已停用',
    statSuspended: '已暂停',
    listTitle: '加速规则',
    listCount: '共 {n} 条',
    filterAll: '全部状态',
    resetFilters: '重置',
    state_active: '运行中',
    state_disabled: '已停用',
    state_suspended: '已暂停',
    reason_plan_expired: '套餐已到期',
    reason_traffic_exceeded: '流量超限',
    reason_requests_exceeded: '请求数超限',
    reason_no_feature: '套餐不含应用加速',
    colName: '规则名称',
    colAccess: '接入地址',
    colOrigins: '源站',
    noAccessHost: '套餐未配置线路',
    proto_tcp: 'TCP',
    proto_udp: 'UDP',
    proto_tcp_udp: 'TCP+UDP',
    stats: '统计',
    more: '更多',
    enable: '启用',
    disable: '停用',
    enabled: '已启用',
    disabled: '已停用',
    deleted: '已删除',
    disableTitle: '停用加速规则',
    disableContent: '停用「{name}」后，端口 {port} 立即关闭，正在进行的连接会断开。',
    deleteTitle: '删除加速规则',
    deleteContent: '删除「{name}」后，端口 {port} 立即关闭并释放，正在进行的连接会断开，删除后无法恢复。',
    noMatch: '没有符合条件的规则',
    create: '新建规则',
    submitCreate: '创建',
    save: '保存',
    saved: '已保存',
    created: '规则已创建，监听端口 {port}',
    searchPlaceholder: '搜索名称、端口或源站',
    edit: '编辑',
    empty: '还没有加速规则，新建一条把 TCP/UDP 端口加速到你的源站',
    noPackage: '你的套餐都不包含应用加速，购买或升级到包含应用加速的套餐后即可新建规则。',
    toStore: '去购买套餐',
    createTitle: '新建加速规则',
    editTitle: '编辑加速规则',
    formIntro: '访客连接「接入地址:监听端口」，边缘节点把 TCP/UDP 流量原样转发到源站，适合游戏、远程桌面、数据库、MQTT 等非 HTTP 业务。',
    accessPreview: '接入地址：',
    portAuto: '自动分配',
    idToken: '规则ID',
    package: '所属套餐',
    packageHint: '规则的流量计入该套餐，接入地址由套餐的线路决定',
    packagePlaceholder: '选择套餐',
    packageNoL4: '不含应用加速',
    packageFull: '规则数已满',
    packageUsed: '已用 {used}/{max}',
    name: '规则名称',
    namePlaceholder: '如：游戏服、远程桌面',
    protocol: '转发协议',
    listenPort: '监听端口',
    listenPortPlaceholder: '留空自动分配',
    listenPortHint: '可用范围 {min}–{max}',
    origins: '源站地址',
    originsPlaceholder: '每行一个，如\n203.0.113.10:7777\ngame.example.com:7777',
    originsHint: '最多 {max} 个，格式 IP:端口 或 域名:端口，IPv6 写作 [地址]:端口；连不上时自动换下一个',
    balance: '负载方式',
    balance_round_robin: '轮询',
    balance_ip_hash: '源 IP 哈希',
    balanceHint_round_robin: '新连接依次分配到各个源站',
    balanceHint_ip_hash: '同一访客 IP 固定连到同一个源站，适合需要会话保持的业务',
    proxyProtocol: 'PROXY 协议',
    proxy_off: '关闭',
    proxy_v1: 'v1',
    proxy_v2: 'v2',
    proxyHint: '向源站传递访客真实 IP，源站须开启对应版本的 PROXY 协议，否则连接会失败；仅对 TCP 生效',
    proxyUdpHint: 'PROXY 协议仅对 TCP 生效',
    remark: '备注',
    remarkPlaceholder: '选填',
  },
  l4stats: {
    title: '{name} · 统计',
    range_1h: '1 小时',
    range_today: '今日',
    range_yesterday: '昨日',
    range_7d: '7 天',
    range_30d: '30 天',
    loadFailed: '统计加载失败',
    noLogs: '未接入日志存储，暂无应用加速统计',
    fig_trafficOut: '下行流量',
    fig_peakOut: '下行峰值带宽',
    fig_conns: '新建连接',
    fig_active: '峰值并发',
    upNote: '上行 {v}',
    connsNote: '源站无响应 {failed} · 拒绝 {refused}',
    activeNote: '同一时刻打开的连接',
    tab_bandwidth: '带宽',
    tab_traffic: '流量',
    tab_conns: '连接数',
    tab_active: '并发',
    down: '下行',
    up: '上行',
    newConns: '新建连接',
    failed: '源站无响应',
    refused: '被拒绝',
    activeLine: '并发连接',
    clientsTitle: '访客排行',
    colIp: '访客 IP',
    colConns: '连接数',
    noClients: '这段时间没有访客',
  },
  complaints: {
    title: '我的投诉',
    unit: '条',
    statAll: '全部投诉',
    statOpen: '处理中',
    statResolved: '已处理',
    statWithdrawn: '已撤销',
    listTitle: '投诉列表',
    listCount: '共 {n} 条',
    fileTitle: '发起投诉',
    searchPlaceholder: '搜索投诉编号或内容',
    filterAll: '全部状态',
    filter_open: '处理中',
    filter_resolved: '已处理',
    filter_withdrawn: '已撤销',
    noMatch: '没有符合条件的投诉',
    empty: '还没有投诉记录。对某个工单的服务不满意时，可以在工单页面点击「投诉」。',
    cat_attitude: '服务态度',
    cat_speed: '响应速度',
    cat_result: '处理结果',
    cat_outage: '服务故障',
    cat_billing: '计费问题',
    cat_other: '其他',
    status_pending: '待处理',
    status_processing: '处理中',
    status_resolved: '已处理',
    status_withdrawn: '已撤销',
    aboutTicket: '工单 {no}',
    view: '查看',
    withdraw: '撤销',
    withdrawTitle: '撤销投诉',
    withdrawContent: '撤销后投诉 {no} 将不再处理，确定撤销吗？',
    withdrawn: '投诉已撤销',
    colComplaint: '投诉',
    colNo: '投诉编号',
    category: '投诉类型',
    content: '投诉内容',
    ticket: '关联工单',
    noTicket: '未关联工单',
    filedAt: '提交时间',
    detailTitle: '投诉详情',
    result: '处理结果',
    handledAt: '处理于 {time}',
    withdrawnNote: '你已撤销这条投诉。',
    waiting_pending: '我们已收到你的投诉，会尽快安排专人处理，处理结果会在这里告诉你。',
    waiting_processing: '专人正在处理你的投诉，处理结果会在这里告诉你。',
    close: '关闭',
    filed: '投诉已提交',
    submit: '提交投诉',
    intro: '投诉会由专人跟进处理，处理结果会在「我的投诉」中告诉你。',
    contentPlaceholder: '请描述遇到的问题和你的诉求，例如：发生了什么、什么时候、希望我们怎么处理。',
    complain: '投诉',
    viewMine: '查看投诉',
  },
  // A message's files and the conversation: components/tickets, the same
  // files in both consoles, so the same keys.
  ticketFiles: {
    add: '添加附件',
    tip: '单个不超过 {mb} MB，最多 {max} 个，截图可直接粘贴',
    uploading: '附件上传中…',
    tooMany: '最多添加 {max} 个附件',
    tooLarge: '「{name}」超过 {max} MB，无法上传',
    empty: '「{name}」是空文件',
    failed: '「{name}」上传失败',
    downloadFailed: '下载失败',
  },
  richEditor: {
    image: '插入图片',
    bold: '加粗',
    italic: '斜体',
    underline: '下划线',
    bulletList: '无序列表',
    numberList: '有序列表',
    link: '插入链接',
    unlink: '取消链接',
    attach: '添加附件',
    linkPlaceholder: '输入链接地址',
    linkApply: '确定',
    badLink: '链接地址不正确',
  },
  ticketThread: {
    secretTag: '保密消息',
    secretReveal: '点击查看',
    secretHide: '隐藏',
    secretPurged: '保密内容已在工单关闭时销毁',
    newMessages: '收到新消息，点击查看',
    newSpoken: '您有一条新的工单消息',
    infoBody: '问题描述',
    infoFiles: '附件',
    infoSite: '相关站点',
    stage_filed: '已建单',
    stage_processing: '处理中',
    stage_closed: '已结单',
    me: '我',
    support: '客服',
    roleCustomer: '客户',
    roleStaff: '客服',
    note: '内部备注',
    ev_accepted: '客服已受理工单',
    ev_assigned: '工单已转交给 {name}',
    ev_assignedSelf: '{name} 接手了工单',
    ev_unassigned: '工单已取消分配',
    ev_priority: '优先级调整为「{priority}」',
    ev_closed_customer: '你关闭了工单',
    ev_closed_staff: '客服关闭了工单',
    ev_closed_auto: '因长时间未回复，工单已自动关闭',
    assistant: '服务助手',
    as_filed: '工单已提交',
    as_filedText: '我们已经收到你的问题，{support}会尽快处理，进展都会在这里告诉你。如需补充信息，可以继续留言。',
    as_accepted: '{support}已受理工单',
    as_acceptedText: '{support}正在处理你的问题，有进展会第一时间在这里回复你。',
    as_closed_customer: '你关闭了工单',
    as_closed_customerText: '感谢你的反馈。如果问题还没有解决，可以重新提交工单。',
    as_closed_staff: '{support}关闭了工单',
    as_closed_staffText: '问题已经处理完毕。如果还有疑问，可以重新提交工单。',
    as_closed_auto: '工单已自动关闭',
    as_closed_autoText: '工单长时间没有新的回复，系统已自动关闭。如果还有疑问，可以重新提交工单。',
  },
  myPackages: {
    autoEdit: '修改',
    autoFailed_insufficientBalance: '「{pkg}」自动续费未成功：账户余额不足。充值后系统会自动完成续费。',
    autoFailed_other: '「{pkg}」自动续费未成功：暂不支持在线续费，请联系客服续费。',
    autoFailed_periodUnavailable: '「{pkg}」自动续费未成功：套餐已不再按所选时长续费，请修改续费时长。',
    autoOff: '未开启',
    autoOn: '续费时长 {period}',
    autoWhen: '，到期前 3 天扣费',
    autoRenew: '自动续费',
    title: '我的套餐',
    intro: '你名下的套餐和到期时间。每个站点属于创建时选择的套餐，套餐到期后该套餐下的站点会暂停服务，访问者看到「网站已暂停服务」页面；续费后一分钟内自动恢复。',
    lapsedAlert: '有套餐已经到期，它下面的 {n} 个站点已经暂停服务。请联系客服续费。',
    endingAlert: '有套餐将在 7 天内到期。为避免站点暂停服务，请及时联系客服续费。',
    packageCol: '套餐',
    stateCol: '状态',
    startedCol: '开始时间',
    expiresCol: '到期时间',
    remainingCol: '剩余',
    sitesCol: '站点',
    state_active: '有效',
    state_expiring: '即将到期',
    state_expired: '已到期',
    daysLeft: '{n} 天',
    hoursLeft: '{n} 小时',
    expiredAgo: '已过期 {n} 天',
    statActive: '生效套餐',
    statExpiring: '即将到期',
    statExpired: '已到期',
    statSites: '套餐下站点',
    startedAt: '开通时间',
    expiresAt: '到期时间',
    meter_traffic: '本期流量',
    meter_requests: '本期请求',
    meter_bandwidth: '实时带宽',
    meter_connections: '并发连接',
    unlimited: '不限',
    sitesValue: '站点 {n} 个',
    resets: '本期 {time} 重置',
    noUsage: '这个套餐不计量用量。',
    empty: '还没有套餐，请联系客服开通。',
    unitSubs: '份',
    count_sites: '站点',
    count_hostnames: '域名',
    count_apexes: '主域名',
    count_rules: '每站点规则',
    count_l4: '应用加速规则',
    rulesPerSiteValue: '{n} 条',
    featureOff: '套餐不含',
    lapsedAlertRenew: '有套餐已经到期，它下面的 {n} 个站点已经暂停服务。续费后一分钟内自动恢复。',
    endingAlertRenew: '有套餐将在 7 天内到期，请及时续费或开启自动续费，避免站点暂停服务。',
    emptyStore: '还没有套餐',
    buy: '购买套餐',
    buySub: '用账户余额购买，即时开通',
    renew: '续费',
  },
  assistant: {
    defaultName: '智能助手',
    newChat: '新对话',
    history: '历史对话',
    expand: '展开',
    shrink: '还原',
    close: '关闭',
    back: '返回',
    hello: '你好，我是{name}',
    helloSub: '站点接入、故障排查、套餐与费用，都可以问我。',
    canDo: '我能帮你做',
    act_onboard: '网站接入',
    act_onboardSub: '一步步把网站接入加速',
    act_diagnose: '报错诊断',
    act_diagnoseSub: '502、证书报错、访问变慢等问题排查',
    act_billing: '套餐与费用',
    act_billingSub: '选择套餐、续费、充值和发票',
    actOnboardAsk: '我想把网站接入加速，需要怎么做？',
    actBillingAsk: '我该怎么选择套餐？到期后怎么续费？',
    actDiagnosePrefill: '请帮我排查：我的站点 ',
    mayAsk: '你可能想问',
    placeholder: '输入你的问题，Shift + Enter 换行',
    send: '发送',
    stop: '停止生成',
    left: '今日还可提问 {n} 次',
    disclaimer: '内容由 AI 生成，仅供参考',
    tryAsk: '试试问：{q}',
    waiting: '正在回答',
    thinking: '思考中',
    stopped: '已停止生成',
    failedBefore: '这次回答没有完成，可以重试',
    retry: '重试',
    copy: '复制',
    copied: '已复制',
    historyEmpty: '还没有对话',
    deleteConfirm: '删除这个对话？',
    deleted: '已删除',
  },
  autoRenew: {
    title: '设置自动续费',
    period: '续费时长',
    charge: '每次扣费',
    when: '扣费时间',
    whenValue: '到期前 3 天，即 {time} 起',
    whenSoon: '开启后 10 分钟内',
    short: '当前余额不足以支付下次续费，请在 {time} 前充值 ¥{amount}，否则续费会失败。',
    shortNow: '当前余额不足以支付这次续费，请充值 ¥{amount}。',
    note: '到期前 3 天自动从账户余额扣费续费，扣费成功或失败都会在控制台提醒并发送到账户邮箱。可随时关闭。',
    turnOn: '开启自动续费',
    turnedOn: '已开启自动续费',
    turnedOff: '已关闭自动续费',
    saved: '已保存',
  },
  credentials: {
    title: 'API 密钥',
    sectionTitle: 'Open API 凭证',
    intro: 'AK/SK 用于通过 Open API 调用 {name}。Secret 只在创建时显示一次，请妥善保存。',
    nameCol: '备注',
    accessKeyCol: 'Access Key',
    statusCol: '状态',
    lastUsedCol: '最近使用',
    createdCol: '创建时间',
    create: '生成密钥',
    nameLabel: '备注（可选）',
    namePlaceholder: '例如：CI 部署机',
    disable: '禁用',
    disableConfirmTitle: '禁用密钥',
    disableConfirm: '禁用后，用这个密钥的调用会立即失败，且不能再启用。',
    secretModalTitle: '请立即复制 Secret',
    secretWarn: 'Secret 仅显示一次，关闭后无法再次查看。',
    secretCopied: '已复制',
    statusActive: '生效中',
    statusDisabled: '已禁用',
    createSuccess: '密钥已生成',
    createFailed: '生成失败',
    disableSuccess: '已禁用',
    disableFailed: '禁用失败',
    statTotal: '密钥总数',
    statActive: '生效中',
    statDisabled: '已禁用',
    statRecent: '近 {n} 天用过',
    listTitle: '全部密钥',
    listCount: '共 {n} 个',
    noName: '未填写备注',
    never: '从未使用',
    nameHint: '写明这个密钥用在哪里，日后停用时好分辨。',
    empty: '还没有 API 密钥',
    noOpenapi: '您的套餐都不包含 OpenAPI：已有密钥暂停使用，也不能新建。换到含 OpenAPI 的套餐后自动恢复。',
    noOpenapiShort: '套餐不包含 OpenAPI',
    statusPaused: '暂停使用',
  },
  // ---- M7.4 套餐 ----------------------------------------------------------
  // ---- 攻击事件 ----------------------------------------------------------
  security: {
    title: '安全事件',
    statBlocked: '拦截次数',
    statEvents: '共 {n} 条事件',
    statIps: '攻击来源',
    statWaf: 'WAF 拦截',
    statCc: 'CC 拦截',
    unitTimes: '次',
    unitIps: '个',
    listTitle: '事件明细',
    window_1: '近 1 小时',
    window_24: '近 24 小时',
    window_168: '近 7 天',
    range_1: '1 小时',
    range_24: '24 小时',
    range_168: '7 天',
    filterAllSites: '全部站点',
    filterAllModules: '全部模块',
    filterAllActions: '全部处置',
    ipPlaceholder: '来源 IP',
    timeCol: '时间',
    hostCol: '域名',
    ipCol: '来源 IP',
    moduleCol: '模块',
    actionCol: '处置',
    ruleCol: '规则',
    uriCol: '请求',
    pageN: '第 {n} 页',
    prev: '上一页',
    next: '下一页',
    noLogs: '未接入日志存储，暂无安全事件',
    empty: '这段时间没有安全事件',
    module_waf: 'WAF',
    module_cc: 'CC',
    module_acl: 'ACL',
    module_bot: 'Bot',
    module_geo: '区域屏蔽',
    module_iplist: 'IP 名单',
    module_challenge: '人机验证',
    module_edge: '边缘',
    module_guard: '节点防护',
    module_site: '站点',
    module_quota: '套餐配额',
    module_upstream: '回源',
    action_pass: '放行',
    action_redirect_https: 'HTTPS 跳转',
    action_challenge: '人机验证',
    action_challenge_verify: '提交验证',
    action_block: 'IP 名单拦截',
    action_block_acl: 'ACL 拦截',
    action_block_waf: 'WAF 拦截',
    action_block_bot: 'Bot 拦截',
    action_block_cc: 'CC 拦截',
    action_block_ban: '封禁拦截',
    action_block_geo: '区域拦截',
    action_log_geo: '区域观察',
    action_block_cross_site: '跨站拦截',
    action_ban: '验证失败封禁',
    action_suspended: '站点暂停',
    action_conn_limit: '连接数超限',
    action_shed: '回源过载',
    action_websocket_off: 'WebSocket 已关闭',
  },
  // ---- 菜单分组 ----------------------------------------------------------
  menu: {
    grpSites: '站点管理',
    grpL4: '应用加速',
    grpSecurity: '安全防护',
    grpBilling: '计费管理',
    grpAccount: '账户设置',
    grpFinance: '财务管理',
    grpTickets: '工单中心',
  },
  // Messages the control plane produced, keyed by the stable code it ships
  // alongside the English text. The console looks the code up here so an
  // operator reads guidance in their own language; anything missing falls
  // back to the server's English rather than showing a bare key.
  quota: {
    usageCol: '本周期用量',
    traffic: '流量',
    requests: '请求数',
    bandwidth: '带宽',
    connections: '连接数',
    unlimited: '不限',
    withBonus: '含加量',
    resetsAt: '{time} 重置',
    exceeded_traffic_exceeded: '流量已用完',
    exceeded_requests_exceeded: '请求数已用完',
    exceededAlert_traffic_exceeded: '套餐「{pkg}」本周期的流量已用完，相关站点已暂停，访问者看到的是「流量超限」页面。{time} 进入下个周期后自动恢复，也可以联系管理员加量或升级套餐。',
    exceededAlert_requests_exceeded: '套餐「{pkg}」本周期的请求数已用完，相关站点已暂停，访问者看到的是「请求数超限」页面。{time} 进入下个周期后自动恢复，也可以联系管理员加量或升级套餐。',
    topUp: '加量',
    reset: '重置用量',
    topUpTitle: '本周期加量',
    topUpIntro: '给 {user} 的「{pkg}」本周期额外增加流量或请求数，下个周期自动失效。因超额暂停的站点会在一分钟内恢复。',
    millionSuffix: '百万次',
    topUpDone: '已加量',
    resetTitle: '重置本周期用量',
    resetConfirm: '把 {user} 的「{pkg}」本周期已用的流量和请求数清零重新计算？因超额暂停的站点会在一分钟内恢复。',
    resetDone: '已重置',
  },
  entitlements: {
    feature_waf: 'WAF',
    feature_custom_cc: '自定义 CC 规则',
    feature_websocket: 'WebSocket',
    feature_http3: 'HTTP/3',
    feature_custom_cert: '自定义证书',
    feature_openapi: 'OpenAPI',
    feature_l4: '应用加速',
  },
  // 人机验证 in the pages (utils/captcha.ts).
  captcha: {
    title: '安全验证',
    googleHint: '请勾选下方的验证框，完成后会自动继续。',
    loadFailed: '人机验证加载失败，请检查网络后重试',
    localTip: '向右拖动滑块完成拼图',
    localPassed: '验证通过',
    localMissed: '没有对准，请再试一次',
    localRefresh: '换一张',
    localRetry: '重试',
    tencentError: '腾讯云验证码出错（错误码 {code}），请稍后再试',
  },
  smsCode: {
    send: '获取验证码',
    resend: '重新获取',
    wait: '{n} 秒后重新获取',
    placeholder: '6 位验证码',
    sent: '验证码已发送至 {phone}',
    failed: '验证码发送失败',
    required: '请输入 6 位短信验证码',
  },
  accountCenter: {
    title: '账户中心',
    basic: '基础信息',
    realname: '实名认证',
    member: '会员等级',
  },
  member: {
    vipTip: 'VIP{n} 会员',
    lvTip: 'LV{lv} · 经验 {cur}/{need}',
    lvTipTop: 'LV{lv} · 已满级',
    top: '已满级',
    vipTitle: 'VIP 会员',
    vipPerkTicket: '会员权益：工单优先处理，你提交的工单会排在客服列表的前面。',
    vipPerkNone: '会员权益以平台公布的为准。',
    vipNone: '你还不是 VIP 会员',
    vipNoneHelp: 'VIP 等级由成长值决定，成长值由平台发放。',
    vipNoneHelpTicket: 'VIP 等级由成长值决定，成长值由平台发放；成为 VIP 后工单优先处理。',
    vipAsk: '咨询开通',
    notVip: '非 VIP',
    growthUnit: '成长值',
    vipToNext: '距 VIP{lv} 还需 {n} 成长值',
    vipTotal: '累计 {n} 成长值',
    vipTop: '已是最高等级',
    lvTitle: '我的等级',
    expUnit: '经验',
    toNext: '距 LV{lv} 还需 {n} 经验',
    total: '累计 {n} 经验',
    ladderCaption: '各等级所需累计经验',
    earnTitle: '获取经验',
    daily: '每日登录',
    dailyHelp: '每天第一次打开控制台即可获得，按北京时间计日。',
    dailyDone: '今日已获得',
    dailyNot: '今日未获得',
    task_realname: '实名认证',
    task_phone: '绑定手机',
    task_guard: '开启登录保护',
    task_site: '添加第一个站点',
    taskHelp_realname: '完成个人或企业实名认证。',
    taskHelp_phone: '用短信验证码验证一个手机号。',
    taskHelp_guard: '绑定 MFA 设备，或开启短信登录保护。',
    taskHelp_site: '在站点列表中添加一个站点。',
    taskGo_realname: '去认证',
    taskGo_phone: '去绑定',
    taskGo_guard: '去开启',
    taskGo_site: '去添加',
    taskDone: '已完成',
    taskRecord: '新手任务 · {task}',
    adjust: '平台调整',
    adjustRecord: '平台调整 · {note}',
    recordsTitle: '经验记录',
    recordsSub: '最近 {n} 条',
    recordsEmpty: '还没有经验记录',
    colTime: '时间',
    colSource: '来源',
    colExp: '经验',
    growthTitle: '成长值记录',
    colNote: '说明',
    colGrowth: '成长值',
    colAfter: '调整后',
    after: '调整后 {n}',
  },
  profile: {
    title: '账户资料',
    leaveTitle: '放弃未保存的修改？',
    leaveBody: '基础信息里有未保存的修改，切换到其他标签后这些修改会丢失。',
    leaveOk: '放弃并切换',
    changeAvatar: '更换头像',
    addAvatar: '上传头像',
    remove: '移除',
    removeTitle: '移除头像',
    removeContent: '移除后头像恢复为用户名首字母。',
    avatarSaved: '头像已更新',
    avatarRemoved: '头像已移除',
    avatarHint: '支持 JPG、PNG、GIF，上传前可裁剪',
    pickTooLarge: '图片不能超过 {max} MB',
    factId: '账号 ID',
    factUsername: '用户名',
    factCreated: '注册时间',
    factRealname: '实名认证',
    factEmail: '邮箱',
    factPhone: '手机号',
    change: '修改',
    bind: '绑定',
    none: '未绑定',
    basicTitle: '基本资料',
    nickname: '昵称',
    nicknameHelp: '显示在控制台右上角和工作台，不填则显示用户名',
    contactTitle: '联系方式',
    contactIntro: '客服处理工单、或通过邮箱和手机联系不上你时使用，仅平台工作人员可见。',
    qqPlaceholder: 'QQ 号码',
    wechat: '微信号',
    wechatPlaceholder: '微信号或绑定的手机号',
    backupName: '备用联系人',
    backupNamePlaceholder: '姓名',
    backupPhone: '备用联系电话',
    backupPhonePlaceholder: '手机或座机，如 010-12345678',
    companyTitle: '公司与行业',
    companyIntro: '帮助我们为你推荐合适的套餐和接入方案，个人用户可只填行业。',
    company: '公司名称',
    companyPlaceholder: '营业执照上的名称',
    industry: '所属行业',
    industryPlaceholder: '请选择行业',
    industry_internet: '互联网/软件',
    industry_ecommerce: '电子商务',
    industry_media: '视频/直播/媒体',
    industry_gaming: '游戏',
    industry_education: '教育',
    industry_finance: '金融',
    industry_government: '政府/公共事业',
    industry_manufacturing: '制造业',
    industry_healthcare: '医疗健康',
    industry_other: '其他',
    teamSize: '团队规模',
    teamPlaceholder: '请选择团队规模',
    team_1_9: '1–9 人',
    team_10_49: '10–49 人',
    team_50_199: '50–199 人',
    team_200_999: '200–999 人',
    team_1000plus: '1000 人以上',
    siteUsage: '网站用途',
    siteUsagePlaceholder: '例如：企业官网、电商、视频点播、下载分发、API 加速',
    addressTitle: '通信地址',
    addressIntro: '用于寄送纸质发票、合同等资料。',
    region: '所在地区',
    regionPlaceholder: '省份 / 城市',
    postcode: '邮政编码',
    country: '所属国家/地区',
    countryPlaceholder: '选择国家或地区，不选视为中国大陆',
    countryHelp: '实名认证按此显示认证方式：中国大陆使用国内认证，其他国家和地区使用国际认证',
    countryLocked: '已完成实名认证，不可修改',
    postcodePlaceholder: '6 位数字',
    address: '详细地址',
    addressPlaceholder: '街道、门牌号、楼层等',
    saved: '账户资料已保存',
    cropTitle: '更换头像',
    cropPreview: '预览',
    cropZoom: '缩放',
    cropHint: '拖动图片调整位置，滚动鼠标滚轮或拖动滑块缩放',
    cropRepick: '重新选择',
    cropSave: '保存头像',
  },
  saveBar: {
    label: '保存操作',
    unsaved: '有未保存的修改',
    reset: '撤销修改',
    fixFirst: '有填写错误，请先修正',
  },
  realname: {
    title: '实名认证',
    state_unverified: '未实名认证',
    state_pending: '认证审核中',
    state_rejected: '认证未通过',
    intro: '完成实名认证后即可使用平台全部功能。认证信息仅用于核验身份，身份证号码加密保存。',
    introVerified: '账号已完成实名认证。如需变更认证主体，请提交工单联系客服。',
    factType: '认证类型',
    typeIndividual: '个人认证',
    typeEnterprise: '企业认证',
    factName: '姓名',
    factCompany: '企业名称',
    factCertNo: '证件号码',
    factMethod: '认证方式',
    via_alipay: '支付宝 · {method}',
    via_tencent: '腾讯云 · {method}',
    via_aliyun: '阿里云 · {method}',
    viaSupport: '客服审核',
    factTime: '认证时间',
    personalTitle: '个人实名认证',
    by_alipay: '支付宝',
    by_tencent: '腾讯云',
    by_aliyun: '阿里云',
    by_sumsub: 'Sumsub',
    by_veriff: 'Veriff',
    via_sumsub: 'Sumsub · {method}',
    via_veriff: 'Veriff · {method}',
    personalSub_sumsub: '由 Sumsub 完成核验',
    personalSub_veriff: '由 Veriff 完成核验',
    agree_sumsub: '我同意将证件照片和人脸影像提交给 Sumsub 用于身份核验',
    agree_veriff: '我同意将证件照片和人脸影像提交给 Veriff 用于身份核验',
    method_SUMSUB_IDV: '证件与人脸核验',
    method_VERIFF_IDV: '证件与人脸核验',
    methodHint_SUMSUB_IDV: '在 Sumsub 页面拍摄护照、身份证件或驾驶证，再进行人脸活体检测，支持全球大多数国家和地区的证件',
    methodHint_VERIFF_IDV: '在 Veriff 页面拍摄护照、身份证件或驾驶证，再进行人脸活体检测，支持全球大多数国家和地区的证件',
    country: '所属国家/地区',
    countryChange: '修改',
    regionHint_cn: '中国大陆的账号使用国内认证方式',
    regionHint_intl: '中国大陆以外的账号使用国际认证：拍摄证件并进行人脸核验',
    stepIntl: '证件与人脸核验',
    scanTitle_intl: '请打开认证页面完成证件与人脸核验，或用手机扫码继续',
    openTitle_intl: '请打开认证页面完成证件与人脸核验',
    intlFor: '{provider} · {method}',
    intlReview: '提交后需要审核，通常几分钟，结果出来后本页会自动更新',
    openIntl: '打开认证页面',
    intlWaiting: '认证结果尚未返回，审核完成后本页会自动更新',
    factDoc: '证件',
    doc_PASSPORT: '护照',
    doc_ID_CARD: '身份证件',
    doc_DRIVERS: '驾驶证',
    doc_RESIDENCE_PERMIT: '居留许可',
    personalSub_alipay: '由支付宝身份验证完成核验',
    personalSub_tencent: '由腾讯云人脸核身完成核验',
    personalSub_aliyun: '由阿里云号码百科完成核验',
    offlineTitle: '暂未开放在线实名认证',
    offlineSub: '请提交工单申请实名认证，客服审核后为你完成认证。',
    toTicket: '提交工单',
    stepFill: '填写信息',
    stepAlipay: '支付宝认证',
    stepWechat: '微信人脸核身',
    stepCheck: '信息核验',
    stepDone: '认证完成',
    method: '认证方式',
    method_SMART_FACE: '快捷认证',
    method_FACE: '人脸认证',
    method_CERT_PHOTO: '证照认证',
    method_CERT_PHOTO_FACE: '证照+人脸认证',
    method_TC_FACE: '微信人脸核身',
    method_TC_ID2: '身份证二要素核验',
    method_TC_PHONE3: '手机号三要素核验',
    methodHint_SMART_FACE: '支付宝根据账户情况自动选择核验方式，已实名的支付宝账户通常无需拍摄，最快完成',
    methodHint_FACE: '在支付宝中进行人脸识别，与身份证照片比对',
    methodHint_CERT_PHOTO: '在支付宝中拍摄身份证人像面和国徽面完成核验',
    methodHint_CERT_PHOTO_FACE: '先拍摄身份证，再进行人脸识别，核验最严格',
    methodHint_TC_FACE: '使用微信扫码打开核身页面，完成活体检测后与公安权威照片比对',
    methodHint_TC_ID2: '核验姓名与身份证号码是否一致，即时出结果，无需刷脸',
    methodHint_TC_PHONE3: '核验姓名、身份证号码与手机号是否属于同一人，即时出结果，无需刷脸',
    method_ALI_ID2: '身份证二要素核验',
    method_ALI_PHONE3: '手机号三要素核验',
    methodHint_ALI_ID2: '核验姓名与身份证号码是否一致，即时出结果，无需刷脸',
    methodHint_ALI_PHONE3: '按运营商实名登记，核验姓名、身份证号码与手机号是否属于同一人，即时出结果',
    certName: '真实姓名',
    certNamePlaceholder: '与身份证一致的姓名',
    certNo: '身份证号码',
    certNoPlaceholder: '18 位居民身份证号码',
    phone: '手机号码',
    phonePlaceholder: '使用本人身份证办理的手机号',
    phoneHelp: '须为登记在本人名下的中国大陆手机号',
    fee: '认证费用',
    feeFree: '本次免费',
    feeFreeLeft: '免费次数剩余 {n} 次，用完后每次 ¥{fee}',
    feeFromBalance: '从账户余额扣除，当前余额 ¥{balance}',
    feeShort: '余额不足',
    toTopup: '去充值',
    feeConfirmTitle: '确认支付认证费用',
    feeConfirm: '本次认证将从账户余额扣除 ¥{fee}（当前余额 ¥{balance}）。如核验服务未能受理本次认证，费用将自动退回。',
    feeConfirmOk: '支付并开始认证',
    agree_alipay: '我同意将以上信息提交给支付宝用于身份核验',
    agree_tencent: '我同意将以上信息提交给腾讯云用于身份核验',
    agree_aliyun: '我同意将以上信息提交给阿里云用于身份核验',
    agreeRequired: '请先勾选同意提交信息用于身份核验',
    start: '开始认证',
    attemptsLeft: '今日还可发起 {n} 次',
    attemptsNone: '今日认证次数已用完，请明天再试',
    scanTitle_alipay: '请使用支付宝扫码完成认证',
    scanTitle_wechat: '请使用微信扫码完成人脸核身',
    openTitle_alipay: '请在支付宝中完成认证',
    openTitle_wechat: '请在手机上完成人脸核身',
    scanFor: '{method} · {name} · {no}',
    left: '剩余时间',
    openAlipay: '打开支付宝',
    openFace: '开始人脸核身',
    done: '我已完成认证',
    refill: '重新填写',
    passedToast: '实名认证成功',
    failedTitle: '认证未通过',
    failedSub: '本次身份核验未通过，请确认信息无误后重新认证。',
    expiredTitle: '认证已超时',
    expiredSub: '30 分钟内未完成认证，请重新发起。',
    notTakenTitle: '认证未能完成',
    notTakenSub: '核验服务未能受理本次认证，不计入免费次数，如有扣费已自动退回。请稍后重试。',
    reason: '原因：{reason}',
    retry: '重新认证',
    enterpriseTitle: '企业实名认证',
    enterpriseRow: '企业认证',
    enterpriseDesc: '企业用户请提交工单并上传营业执照，客服审核后为你完成企业实名认证。',
    enterpriseGo: '提交工单',
    ticketBody_enterprise: '申请企业实名认证\n企业名称：\n统一社会信用代码：\n联系人及电话：\n（请在附件中上传营业执照照片）',
    ticketBody_individual: '申请个人实名认证\n姓名：\n联系电话：',
    doneTitle: '认证流程已结束',
    doneSub: '请回到发起认证的页面查看认证结果。',
    doneGo: '查看认证结果',
  },
  subUsers: {
    title: '子用户',
    statTotal: '子用户总数',
    statActive: '已启用',
    statDisabled: '已停用',
    statRecent: '近 {n} 天登录',
    unit: '个',
    listTitle: '子用户列表',
    listCount: '共 {n} 个，最多 {max} 个',
    create: '新建子用户',
    full: '每个账号最多创建 {max} 个子用户',
    intro: '子用户使用主账号 ID、子用户名和密码，在登录页「其他登录方式 › 子用户」中登录。子用户拥有与主账号相同的权限，但不能管理子用户，也不能修改主账号的登录密码、MFA、通行密钥等安全设置。',
    ownerId: '主账号 ID',
    ownerIdTip: '子用户登录时在第一栏填写',
    empty: '还没有子用户',
    colName: '子用户名',
    colRemark: '备注',
    colStatus: '状态',
    colLastLogin: '最近登录',
    colCreated: '创建时间',
    status_active: '启用',
    status_disabled: '停用',
    never: '从未登录',
    resetPassword: '重置密码',
    disable: '停用',
    enable: '启用',
    namePlaceholder: '例如 ops、dev.zhang',
    nameRequired: '请填写子用户名',
    nameRule: '3-32 位字母、数字或 _ . -，以字母或数字开头',
    password: '登录密码',
    passwordRequired: '请填写登录密码',
    newPassword: '新密码',
    generate: '随机生成',
    remarkPlaceholder: '例如 运维同事张三',
    remarkTooLong: '备注最多 {max} 个字符',
    permissionNote: '子用户拥有与主账号相同的权限（暂不区分权限），请只为信任的人创建。',
    editTitle: '编辑子用户 {name}',
    passwordTitle: '重置 {name} 的密码',
    passwordNote: '重置后，该子用户所有已登录的会话将立即失效。',
    issuedTitle: '子用户登录信息',
    issuedWarn: '密码只显示这一次，请复制后妥善交给子用户。',
    loginUrl: '登录地址',
    copyAll: '复制登录信息',
    copyFailed: '复制失败，请手动选择复制',
    done: '完成',
    saved: '已保存',
    enabled: '已启用子用户 {name}',
    disabledDone: '已停用子用户 {name}，其登录会话已失效',
    disableTitle: '停用子用户 {name}？',
    disableConfirm: '停用后该子用户将无法登录，已登录的会话会立即失效。之后可随时重新启用。',
    deleteTitle: '删除子用户 {name}？',
    deleteConfirm: '删除后该子用户将无法再登录，已登录的会话会立即失效，且无法恢复。',
    deleted: '已删除子用户 {name}',
    createFailed: '创建失败',
    saveFailed: '保存失败',
    deleteFailed: '删除失败',
  },
  subSecurity: {
    tag: '子用户',
    signedInto: '登录在主账号 {name} 下',
    owner: '主账号',
    remark: '备注',
    lastLogin: '最近登录',
    passwordDesc: '子用户自己的登录密码。修改后，该子用户其他设备上的登录会立即失效。',
    passwordNote: '修改后，当前浏览器保持登录，其他设备上的登录将立即失效。',
    scope: '子用户与主账号拥有相同的资源权限；主账号的登录密码、MFA、通行密钥、登录记录和子用户只能由主账号管理。',
  },
  securityCenter: {
    title: '安全中心',
    accountId: '账号 ID：{id}',
    level: '安全等级',
    level_low: '低',
    level_medium: '中',
    level_high: '高',
    tipMfa: '绑定 MFA 设备后，即使密码泄露，账号也不会被盗用',
    tipPassword: '密码已超过 {days} 天没有修改，建议更换',
    tipGood: '账号已开启全部安全防护',
    recentFails: '最近 {days} 天有 {n} 次登录失败。如果不是您本人操作，请立即修改密码并绑定 MFA 设备。',
    email: '邮箱',
    phone: '手机号',
    registered: '注册时间',
    lastLogin: '上次登录',
    unbound: '未绑定',
    settingsTitle: '安全设置',
    password: '登录密码',
    passwordDesc: '建议定期更换，不要与其他网站使用相同的密码。',
    passwordChanged: '上次修改于 {time}。',
    mfa: 'MFA 设备',
    mfaOnDesc: '已绑定，登录时需要输入身份验证器上的 6 位动态码。绑定于 {time}。',
    mfaOffDesc: '未绑定。绑定后，登录时除了密码还需要输入手机身份验证器上的动态码。',
    emailDesc: '{email}，用于接收工单回复和平台通知。',
    sessions: '其他登录',
    sessionsDesc: '在别人的电脑上登录过，或者怀疑账号被盗用时，可以让当前浏览器以外的所有登录立即失效。',
    change: '修改',
    bind: '绑定',
    unbind: '解绑',
    endOthers: '退出其他设备',
    logsTitle: '登录记录',
    logsSub: '最近 {n} 次',
    colTime: '时间',
    colResult: '结果',
    colIp: 'IP 地址',
    colDevice: '设备',
    colMethod: '登录方式',
    method_password: '密码',
    method_code: '验证码',
    method_passkey: '通行密钥',
    method_sub_user: '子用户 {name}',
    passkeys: '通行密钥',
    passkeysOnDesc: '已添加 {n} 个通行密钥，可使用指纹、面容或设备密码直接登录，无需输入密码。',
    passkeysOffDesc: '添加后可使用指纹、面容或设备密码直接登录，无需输入密码，私钥只保存在你的设备中。',
    manage: '管理',
    add: '添加',
    result_success: '登录成功',
    result_bad_password: '密码错误',
    result_bad_mfa: '动态码错误',
    result_inactive: '账号已停用',
    unknownDevice: '未知设备',
    logsEmpty: '暂无登录记录',
    saveFailed: '保存失败',
    passwordTitle: '修改登录密码',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    currentRequired: '请输入当前密码',
    newRequired: '请输入新密码',
    confirmRequired: '请再次输入新密码',
    passwordRule: '{min}–{max} 位，至少包含字母、数字、符号中的两种',
    passwordSame: '新密码不能与当前密码相同',
    passwordMismatch: '两次输入的密码不一致',
    passwordNote: '修改后，其他设备上的登录会立即失效，当前浏览器保持登录。',
    strength: '强度',
    strength_1: '弱',
    strength_2: '中',
    strength_3: '强',
    passwordDone: '密码已修改，其他设备上的登录已失效',
    emailTitle: '修改邮箱',
    phoneTitle: '修改手机号',
    phoneBindTitle: '绑定手机号',
    emailHint: '工单回复和平台通知会发到这个邮箱',
    emailRequired: '请输入邮箱',
    emailInvalid: '请输入正确的邮箱地址',
    loginPassword: '登录密码',
    passwordRequired: '请输入登录密码',
    confirmWithPassword: '为确认是您本人操作，请输入登录密码',
    contactDone: '已保存',
    mfaTitle: '绑定 MFA 设备',
    mfaStep1: '在手机上安装身份验证器应用，例如腾讯身份验证器、Google Authenticator 或 Microsoft Authenticator。',
    mfaStep2: '用应用扫描下面的二维码，添加账号。',
    mfaManual: '无法扫码时，在应用中手动输入密钥：',
    mfaStep3: '输入应用里显示的 6 位动态码和登录密码，完成绑定。',
    mfaCode: '动态码',
    mfaCodeHint: '打开身份验证器应用，输入当前显示的 6 位数字',
    mfaCodeRequired: '请输入 6 位动态码',
    mfaDone: 'MFA 设备已绑定，下次登录时需要输入动态码',
    mfaUnbindTitle: '解绑 MFA 设备',
    mfaUnbindWarn: '解绑后，登录只需要密码，账号安全等级会降低。设备丢失、无法获取动态码时，请联系平台管理员重置。',
    mfaUnbindDone: 'MFA 设备已解绑',
    endOthersTitle: '退出其他设备',
    endOthersConfirm: '账号在当前浏览器以外的所有登录都会立即失效，需要重新登录。确定继续吗？',
    endOthersDone: '其他设备上的登录已失效',
    tipSecondStep: '绑定 MFA 设备或开启短信登录保护后，即使密码泄露，账号也不会被盗用',
    loginSms: '登录保护',
    loginSmsOnDesc: '已开启，登录时需要输入发送到 {phone} 的短信验证码。',
    loginSmsOffDesc: '未开启。开启后，登录时除了密码，还需要输入发送到已验证手机号的短信验证码。',
    loginSmsNeedsPhone: '未开启。需要先验证手机号，开启后登录时需要输入短信验证码。',
    loginSmsNeedsPhoneFirst: '请先验证手机号',
    turnOn: '开启',
    turnOff: '关闭',
    verify: '验证',
    phoneOffSmsDesc: '未绑定。绑定并验证后，可用于短信登录保护和找回密码。',
    phoneProvedDesc: '{phone}，已验证，可用于短信登录保护和找回密码。',
    phoneUnprovedDesc: '{phone}，未验证。验证后可用于短信登录保护和找回密码。',
    phoneInvalid: '请输入正确的手机号',
    phoneVerifyTitle: '验证手机号',
    phoneSmsHint: '先选择国家或地区的区号，再填写手机号。清空后保存，即解除绑定',
    phoneDone: '手机号已验证',
    phoneRemoved: '手机号已解除绑定',
    loginSmsOnTitle: '开启登录保护',
    loginSmsOffTitle: '关闭登录保护',
    loginSmsOnNote: '开启后，每次登录除了密码，还需要输入发送到 {phone} 的短信验证码。',
    loginSmsOffWarn: '关闭后，登录只需要密码，账号安全等级会降低。',
    loginSmsOnDone: '登录保护已开启',
    loginSmsOffDone: '登录保护已关闭',
    result_bad_sms: '短信验证码错误',
    result_bad_email_code: '邮箱验证码错误',
    result_password_reset: '通过短信重置密码',
    phoneNoSmsDesc: '未绑定。平台开通短信服务后，可以通过短信验证码绑定。',
    phoneUnprovedNoSmsDesc: '{phone}，未验证。平台开通短信服务后，可以通过短信验证码验证。',
  },
  passkeys: {
    title: '通行密钥',
    addTitle: '添加通行密钥',
    intro: '通行密钥让你使用指纹、面容或设备密码登录，无需输入密码。私钥只保存在你的设备中，平台只保存公钥，无法被钓鱼网站盗用。',
    blocked_browser: '当前浏览器不支持通行密钥，请升级浏览器后再添加',
    blocked_domain: '通行密钥需要通过 HTTPS 域名访问控制台，当前地址无法添加或使用',
    colName: '名称',
    colAdded: '添加时间',
    colUsed: '最近使用',
    rename: '重命名',
    deleteConfirm: '删除后将无法再用它登录。设备中保存的通行密钥需在设备的密码管理中自行移除。',
    empty: '还没有添加通行密钥',
    count: '已添加 {n} / {max} 个',
    add: '添加通行密钥',
    close: '关闭',
    name: '名称',
    nameHint: '用于区分不同设备，例如「办公室 MacBook」',
    nameRequired: '请填写名称',
    nameTooLong: '名称最多 {max} 个字符',
    addNote: '点击「继续」后，请按浏览器提示完成指纹、面容或设备密码验证。',
    continue: '继续',
    added: '已添加通行密钥「{name}」',
    deleted: '已删除通行密钥「{name}」',
    cancelled: '已取消添加通行密钥',
    deviceHasOne: '这台设备已经为该账号保存过通行密钥了',
    addFailed: '添加通行密钥失败',
    renameFailed: '重命名失败',
    deleteFailed: '删除失败',
  },
  inbox: {
    title: '消息中心',
    settings: '消息接收配置',
    settingsTitle: '消息接收配置',
    settingsIntro: '选择每类消息的接收方式：站内信显示在右上角的消息通知和消息中心，邮件发送到账号绑定的邮箱。修改后立即生效。',
    settingsIntroStaff: '选择每类消息是否以站内信接收：站内信显示在右上角的消息通知和消息中心。工单邮件通知发送到工单设置中的通知邮箱（已分配处理人的工单发给处理人）。',
    prefSaved: '已保存',
    unreadCount: '{n} 条未读',
    readAll: '全部已读',
    allRead: '已全部标为已读',
    more: '查看更多',
    empty: '暂无消息',
    emptyUnread: '没有未读消息',
    attention: '{n} 项待处理',
    tabAll: '全部消息',
    tabUnread: '未读消息',
    categoryAll: '全部类型',
    category_ticket: '工单通知',
    category_billing: '财务通知',
    category_node: '节点通知',
    markRead: '标为已读',
    delete: '删除',
    deleted: '已删除',
    deleteTitle: '删除 {n} 条消息？',
    deleteContent: '删除后不可恢复。',
    view: '查看',
    detail: '消息详情',
    follow: '前往查看',
    close: '关闭',
    colTitle: '消息标题',
    colCategory: '类型',
    colTime: '时间',
    colActions: '操作',
    colEvent: '消息',
    channelInbox: '站内信',
    channelMail: '邮件',
    event_ticket_new_staff: '新工单',
    event_ticket_reply_staff: '客户回复工单',
    event_ticket_reply_customer: '工单有新回复',
    event_ticket_resolved: '工单处理完毕',
    event_ticket_closed: '工单关闭',
    event_ticket_auto_closed: '工单自动关闭',
    event_autorenew_ok: '自动续费成功',
    event_autorenew_failed: '自动续费失败',
    eventHint_ticket_new_staff: '客户提交新工单时；已分配处理人的工单只通知处理人',
    eventHint_ticket_reply_staff: '客户在工单中回复时；已分配处理人的工单只通知处理人',
    eventHint_ticket_reply_customer: '客服回复您的工单时',
    eventHint_ticket_resolved: '客服回复并关闭您的工单时',
    eventHint_ticket_closed: '您的工单被关闭时',
    eventHint_ticket_auto_closed: '工单长时间没有回复被自动关闭时',
    eventHint_autorenew_ok: '套餐用账户余额自动续费成功后',
    eventHint_autorenew_failed: '套餐自动续费未能完成时',
  },
  serverErrors: {
    emailCode: {
      unavailable: '平台还没有开启邮件服务，暂时无法发送邮箱验证码',
      badEmail: '请填写正确的邮箱地址',
      tooMany: '获取验证码过于频繁，请稍后再试',
      wrong: '邮箱验证码不正确',
      expired: '邮箱验证码已失效，请重新获取',
      tooSoon: '请 {seconds} 秒后再获取验证码',
      dailyLimit: '这个邮箱今天获取验证码的次数已达上限（{max} 次），请明天再试',
    },
    assistant: {
      badBaseURL: 'API 地址需以 http:// 或 https:// 开头',
      badDailyLimit: '每人每日次数为 0（不限）到 1000',
      badIcon: '不支持的图标：{value}',
      badKey: '模型服务拒绝了 API Key，请检查是否填写正确',
      badLauncher: '不支持的按钮样式：{value}',
      badMaxTokens: '单次回答上限为 256 到 8192 tokens',
      badModel: "模型名称只能包含字母、数字和 . _ : / {'@'} -",
      badName: '名称最多 {max} 个字',
      badPlacement: '不支持的显示位置：{value}',
      badProvider: '不支持的服务商：{value}',
      badSuggestion: '每条推荐问题最多 {max} 个字',
      badTemperature: '温度为 0 到 2',
      baseURLRequired: '请填写 API 地址',
      busy: '上一个回答还在生成，请稍候或先停止',
      dailyLimit: '今天的 {limit} 次提问已用完，明天再来吧',
      emptyAnswer: '模型没有给出回答，请重试',
      emptyQuestion: '请输入问题',
      encryptionKeyMissing: '请先在 control.yaml 中配置 secrets.encryption_key，才能保存 API Key',
      keyRequired: '请填写 API Key',
      modelRequired: '请填写模型',
      promptTooLong: '补充说明最多 {max} 个字',
      providerBalance: '模型服务账户余额不足，请联系平台管理员',
      questionTooLong: '问题最多 {max} 个字',
      rateLimited: '模型服务繁忙，请稍后再试',
      timeout: '模型响应超时，请重试',
      tooManySuggestions: '推荐问题最多 {max} 条',
      unavailable: 'AI 助手暂未开启',
      unreachable: '无法连接模型服务，请稍后再试',
      upstream: '模型服务返回错误（{status}）：{message}',
    },
    profile: {
      badNickname: '昵称最多 {max} 个字',
      badBackupName: '联系人姓名最多 {max} 个字',
      badCompany: '公司名称最多 {max} 个字',
      badAddress: '详细地址最多 {max} 个字',
      badSiteUsage: '网站用途最多 {max} 个字',
      badRegion: '请选择所在省份和城市',
      badQQ: 'QQ 号为 5～12 位数字',
      badWeChat: '微信号为 6～20 位字母、数字、- 或 _，以字母开头；也可以填绑定的手机号',
      badBackupPhone: '请填写正确的联系电话，可包含数字、+、-、括号和空格',
      badIndustry: '不支持的行业：{value}',
      badTeamSize: '不支持的团队规模：{value}',
      badPostcode: '邮政编码为 6 位数字',
      badCountry: '不支持的国家或地区：{value}',
      countryLocked: '已完成实名认证，所属国家/地区不可修改',
      avatarBadImage: '请上传 PNG、JPEG 或 GIF 图片，宽高至少 64 像素',
      avatarTooLarge: '图片不能超过 {max} MB',
    },
    systemUpdate: {
      noReleaseKey: '当前版本没有内置发布公钥，无法校验更新',
      upToDate: '主控已是最新版本',
      noUpdater: '主控机尚未安装更新服务（cdnx-updater）',
      busy: '正在更新中，请等待完成',
      notChecked: '请先检查更新',
      badReleaseUrl: '版本仓库的地址不是 http(s) 地址',
      checkFailed: '无法读取版本仓库：{detail}',
      badComponent: '组件只能是节点程序或边缘程序',
      succeeded: '主控已从 {from} 更新到 {to}',
      rolled_back: '更新到 {to} 失败，已恢复到 {from}',
      failed: '更新到 {to} 失败',
      artifactsPreparing: '主控正在下载节点要用的新版本，请稍等一分钟再试',
      artifactsFailed: '主控没能下载节点要用的新版本（正在重试）：{detail}',
    },
    realname: {
      badFee: '每次认证费用最多 {max}',
      badFree: '免费认证次数为 0～100 次',
      badPhone: '请填写本人名下的中国大陆手机号',
      badProvider: '不支持的认证接口：{value}',
      badRegion: '{value} 不是有效的地域，例如 ap-guangzhou',
      badRuleId: 'RuleId 只能是数字',
      badSecretId: 'SecretId 为 16～64 位字母和数字',
      badSecretKey: 'SecretKey 格式不正确',
      insufficientBalance: '本次认证费用 {fee}，账户余额 {balance}，请先充值',
      numberGone: '这条记录没有保留证件号码',
      ruleRequired: '微信人脸核身需要填写业务规则 RuleId',
      tencentKeyRequired: '请填写腾讯云 SecretId 和 SecretKey',
      aliyunKeyRequired: '请填写阿里云 AccessKey ID 和 AccessKey Secret',
      authCodeRequired: '{method}需要填写对应标签的授权码',
      badAccessKeyId: 'AccessKey ID 应为 12–64 位字母和数字',
      badAccessKeySecret: '这不是有效的 AccessKey Secret',
      badAuthCode: '授权码应为 4–64 个字符，不能含空格',
      unavailable: '平台暂未开放在线实名认证',
      already: '账号已完成实名认证',
      badMethod: '请选择平台提供的认证方式',
      badName: '请填写与身份证一致的姓名',
      badCertNo: '请填写正确的 18 位居民身份证号码',
      startFailed: '认证服务暂时无法发起，请稍后再试',
      notFound: '认证记录不存在',
      tooMany: '今天已发起 {max} 次认证，已达上限，请明天再试',
      identityTaken: '该身份证已认证 {max} 个账号，已达上限',
      unknownMethod: '不支持的认证方式：{value}',
      noMethods: '实名认证列表中请至少显示一种认证方式',
      badDefault: '默认认证方式须为列表中显示的方式',
      duplicateMethod: '{method}已在实名认证列表中',
      sumsubKeyRequired: '请填写 Sumsub 的 App Token 和 Secret Key',
      levelRequired: '请填写 Sumsub 的认证级别名称',
      veriffKeyRequired: '请填写 Veriff 的 API Key 和 Shared Secret Key',
      badAppToken: 'App Token 格式不正确',
      badLevelName: '认证级别名称只能包含字母、数字、空格、. _ -',
      badVeriffKey: 'API Key 格式不正确',
      badSumsubSecret: 'Secret Key 格式不正确',
      badVeriffSecret: 'Shared Secret Key 格式不正确',
      badDaily: '每日认证次数为 1～20 次',
      badMaxAccounts: '同一身份证可认证 1～10 个账号',
      encryptionKeyMissing: '请先在 control.yaml 中配置 secrets.encryption_key，再开启实名认证',
    },
    notify: {
      unknownEvent: '没有这类消息',
    },
    msgtpl: {
      badSubject: '邮件标题为 1～200 个字',
      badTitle: '正文标题为 1～100 个字',
      badBody: '正文最多 2000 个字',
      badButton: '按钮文字为 1～20 个字',
      badInboxTitle: '站内信标题为 1～100 个字，中文和英文都要填写',
      badInboxBody: '站内信正文最多 1000 个字（中文和英文各自计算）',
      unknownVar: "这封邮件没有变量 {name}",
      unknownEvent: '没有这个消息：{value}',
    },
    captcha: {
      required: '请先完成人机验证',
      failed: '人机验证未通过，请重试',
      unavailable: '人机验证服务暂时不可用，请稍后再试',
      changed: '验证方式已更换，请重新验证',
      busy: '验证请求太频繁，请稍后再试',
      incomplete: '请先填写所选验证码服务的全部密钥，再开启人机验证',
      unknownProvider: '不支持的验证码服务：{value}',
      unknownOnError: '不支持的异常处理方式：{value}',
      unknownLoginMode: '登录验证只能选关闭、密码输错后或每次登录',
      failuresRange: '输错次数须在 {min} 到 {max} 之间',
      badTencentAppId: 'CaptchaAppId 只能是数字',
      badSecretId: 'SecretId 为 16 到 64 位字母和数字',
      badGeeTestId: '极验 ID 为 16 到 64 位字母和数字',
      badSiteKey: 'reCAPTCHA 网站密钥为 20 到 64 位字母、数字、- 或 _',
      badHost: 'reCAPTCHA 加载地址只能是 www.recaptcha.net 或 www.google.com',
      badSecret: '密钥格式不正确',
      encryptionKeyMissing: '请先在 control.yaml 中设置 secrets.encryption_key，才能保存密钥',
    },
    sms: {
      unavailable: '平台还没有开启短信服务',
      badPhone: '请填写正确的手机号',
      intlUnavailable: '暂不支持向中国大陆以外的手机号发送验证码',
      intlTemplateRequired: '请先在 消息模板 → 短信模板 → 通用模板 中填写国际号码的阿里云模板 CODE',
      smsbaoKeyRequired: '请填写短信宝的用户名和密码（或 ApiKey）',
      badSmsbaoUser: "短信宝用户名只能包含字母、数字、_ . {'@'} -",
      badSmsbaoTemplate: "短信内容须包含 {'{'}code{'}'}（验证码的位置），且不能过长",
      tooSoon: '请 {seconds} 秒后再获取验证码',
      dailyLimit: '这个手机号今天获取验证码的次数已达上限（{max} 次），请明天再试',
      tooMany: '获取验证码过于频繁，请稍后再试',
      sendFailed: '短信发送失败，请稍后再试',
      codeWrong: '短信验证码不正确',
      codeExpired: '短信验证码已失效，请重新获取',
      providerError: '阿里云短信返回 {code}：{message}',
      unreachable: '无法连接短信服务商：{reason}',
      badProvider: '不支持的短信服务商：{value}',
      badAccessKey: 'AccessKey ID 只能包含字母和数字',
      badTemplate: '{value} 不是有效的模板 CODE，格式如 SMS_123456789',
      badTemplateParam: '{value} 不是有效的模板变量名',
      badSign: '短信签名最多 32 个字符',
      badTTL: '验证码有效期为 1–30 分钟',
      badInterval: '同号码发送间隔为 30–600 秒',
      badDaily: '每号码每日上限为 1–100 条',
      encryptionKeyMissing: '主控未配置加密密钥（control.yaml 的 secrets.encryption_key），暂时不能保存 AccessKey Secret',
      accessKeyRequired: '请填写 AccessKey ID',
      secretRequired: '请填写 AccessKey Secret',
      signRequired: '请填写短信签名',
      templateRequired: '请先在 消息模板 → 短信模板 → 通用模板 中填写国内号码的阿里云模板 CODE',
    },
    account: {
      wrongPassword: '登录密码不正确',
      passwordSame: '新密码不能与当前密码相同',
      passwordWeak: '密码需要 {min}–{max} 位，并且至少包含字母、数字、符号中的两种',
      emailInvalid: '邮箱格式不正确',
      emailTaken: '这个邮箱已被其他账号使用',
      phoneInvalid: '手机号格式不正确',
      mfaUnavailable: '平台还没有配置加密密钥，暂时不能绑定 MFA 设备，请联系平台管理员',
      mfaBound: '已经绑定了 MFA 设备',
      mfaNotBound: '还没有绑定 MFA 设备',
      mfaSecretInvalid: '密钥无效，请关闭窗口后重新绑定',
      phoneNeedsCode: '绑定或修改手机号需要短信验证码',
      phoneNotVerified: '请先验证手机号',
    },
    finance: {
      accountExists: '这个支付宝账号已经添加过了',
      accountFormat: '支付宝账号是邮箱或 11 位手机号',
      accountIncomplete: '第 {n} 个收款账户需要填写户名、开户行和账号',
      accountName: '请填写支付宝账号的实名姓名',
      accountTooLong: '第 {n} 个收款账户有内容过长',
      approveAmount: '通过金额需在 ¥0.01 到 ¥{max} 之间',
      autoRenewCancelled: '已退订的套餐不能自动续费',
      badFee: '手续费率需在 0‰ 到 1000‰ 之间，最低手续费不能为负',
      badMin: '最低金额需在 ¥0.01 到 ¥{max} 之间',
      badRefundDays: '可退款天数需在 0 到 {max} 天之间',
      badUpload: '没有找到附件，请重新上传',
      badUploadPurpose: '不支持的上传类型',
      badUploadType: '只支持 PNG、JPEG、WebP 图片和 PDF 文件',
      badWithdrawRange: '单笔提现最低 ¥0.10，最高不超过 ¥{max}，且不低于最低金额',
      email: '邮箱格式不正确',
      emailRequired: '电子发票需要接收邮箱，请先在发票信息中填写',
      emptyUpload: '文件是空的',
      expressRequired: '请填写快递公司和快递单号',
      feeOverMin: '按最低提现金额计算，扣除手续费后不足 ¥0.10，请调低手续费或提高最低金额',
      insufficientBalance: '账户余额 ¥{balance}，需支付 ¥{amount}，请先充值',
      invoiceBadProfile: '请选择一个发票抬头',
      invoiceClosed: '暂不支持申请发票',
      invoiceFileRequired: '请上传电子发票文件',
      invoiceMedium: '不支持这种开票方式',
      invoiceMin: '单张发票金额不能低于 ¥{min}',
      invoiceNoKind: '至少开放一种发票类型和一种开票方式',
      invoiceNumber: '请填写发票号码（8–24 位数字或字母）',
      invoiceType: '不支持这种发票类型',
      labelTooLong: '备注最多 {max} 个字',
      mailIncomplete: '纸质发票需要收件人、联系电话和邮寄地址，请先在发票信息中填写',
      noteRequired: '请填写原因',
      noteTooLong: '说明最多 {max} 个字',
      overCashable: '最多可提现或退款 ¥{max}：已开票的金额不能提现或退款',
      overInvoiceable: '最多可开票 ¥{max}',
      packageNotOnSale: '这个套餐暂未出售',
      periodUnavailable: '套餐「{package}」不出售这个购买时长',
      refundAmount: '请填写退款金额',
      refundBadOrder: '请选择一笔已支付的订单',
      refundClosed: '暂不支持申请退款',
      refundExpired: '这笔订单已超过可退款期限',
      refundNoWindow: '开启退款前，请至少为充值或套餐订单设置可退款天数',
      refundOver: '这笔订单最多可退 ¥{max}',
      refundReason: '请填写退款原因，最多 {max} 个字',
      refundUnavailable: '支付宝未配置，无法原路退款',
      remitAmount: '汇款金额需在 ¥{min} 到 ¥{max} 之间',
      remitBadAccount: '请选择汇入的收款账户',
      remitBadDate: '汇款日期需在最近 90 天内',
      remitClosed: '暂不支持线下汇款',
      remitNoAccount: '开启线下汇款前，请先添加收款账户',
      remitPayerRequired: '请填写汇款户名',
      remitReceiptRequired: '请上传银行汇款凭证',
      remitTooLong: '有内容过长',
      renewConflict: '该套餐刚刚已续费，请刷新后查看',
      reviewNoteTooLong: '备注最多 {max} 个字',
      specialIncomplete: '专用发票需要企业抬头，并填写注册地址、注册电话、开户银行和银行账号',
      stale: '这笔单据已经变化，请刷新后再操作',
      storeClosed: '暂不支持在线购买套餐',
      taxNo: '企业抬头需要填写纳税人识别号（15–20 位数字或大写字母）',
      titleKind: '请选择个人或企业',
      titleRequired: '请填写发票抬头，最多 100 个字',
      titleTooLong: '有内容过长',
      tooManyAccounts: '收款账户最多 {max} 个',
      tooManyPending: '已有 {max} 笔申请在处理中，请等处理完再提交',
      tooManyProfiles: '发票抬头最多 {max} 个',
      tooManyWithdrawAccounts: '提现账户最多 {max} 个',
      transferUnavailable: '支付宝需要使用公钥证书加签方式才能自动转账',
      uploadTooLarge: '文件不能超过 {max} MB',
      withdrawAmount: '单笔提现金额需在 ¥{min} 到 ¥{max} 之间',
      withdrawBadAccount: '请选择一个提现账户',
      withdrawClosed: '暂不支持提现',
    },
    ticket: {
      confidentialClose: '保密消息会在工单关闭时销毁，不能和关闭工单一起发送',
      badAssignee: '请选择一位客服人员',
      badAttachment: '有附件已失效或不属于你，请重新上传',
      badAutoClose: '自动关闭天数需在 0 到 {max} 天之间',
      badCategory: '请选择问题分类',
      badDomain: '请选择你自己的站点',
      badEmail: '「{value}」不是有效的邮箱地址',
      badPriority: '请选择优先级',
      badRating: '请选择 1 到 5 星',
      badUploadType: '只支持图片、PDF、文本和压缩包文件',
      bodyRequired: '请填写内容',
      bodyTooLong: '内容最多 {max} 个字',
      categoryName: '第 {n} 个分类需要填写名称，最多 20 个字',
      categoryRequired: '允许提交工单时，至少要启用一个问题分类',
      closed: '工单已关闭，不能再回复；如有需要请提交新工单',
      closedAlready: '工单已经关闭了',
      closedForNew: '暂不支持在线提交工单，请联系客服',
      commentTooLong: '评价最多 {max} 个字',
      emptyUpload: '文件是空的',
      notClosed: '工单关闭后才能评价',
      notOpen: '只有待处理的工单可以受理',
      alreadyAccepted: '客服已接手这张工单，请直接回复',
      noticeTooLong: '提交须知最多 {max} 个字',
      supportNameTooLong: '客服名称最多 {max} 个字',
      rated: '这个工单已经评价过了',
      templateBody: '请填写回复内容，最多 {max} 个字',
      templateTitle: '请填写模板名称，最多 {max} 个字',
      titleLength: '标题需要 2 到 {max} 个字',
      tooManyCategories: '问题分类最多 {max} 个',
      tooManyEmails: '通知邮箱最多 {max} 个',
      tooManyFiles: '每条回复最多上传 {max} 个附件',
      tooManyOpen: '你已有 {max} 个未关闭的工单，请先关闭已解决的工单',
      tooManyTemplates: '快捷回复最多 {max} 条',
      tooManyUploads: '已有 {max} 个附件等待发送，请先提交或稍后再试',
      uploadTooLarge: '单个文件不能超过 {max} MB',
    },
    complaint: {
      ticketRequired: '投诉需要在相关工单的页面发起',
      badCategory: '请选择投诉类型',
      contentLength: '投诉内容需要 {min}–{max} 个字',
      badTicket: '请选择你自己的工单',
      openForTicket: '这个工单已有一条投诉正在处理，请等待处理结果',
      tooManyOpen: '已有 {max} 条投诉正在处理，请等待处理结果后再提交',
      done: '这条投诉已处理或已撤销',
      notPending: '只有待处理的投诉可以受理',
      resultLength: '请填写处理结果，最多 {max} 个字',
    },
    mail: {
      auth: 'SMTP 服务器拒绝了登录：{reason}',
      badFrom: '「{value}」不是有效的发件人地址',
      badHost: '「{value}」不是有效的服务器地址',
      badPort: '端口需在 1 到 65535 之间',
      badRecipient: '「{value}」不是有效的邮箱地址',
      badSecurity: '不支持的加密方式：{value}',
      badURL: '「{value}」不是有效的控制台地址，格式如 https://cdn.example.com',
      connect: '无法连接 SMTP 服务器：{reason}',
      encryptionKeyMissing: '请先在 control.yaml 中设置 secrets.encryption_key，再保存 SMTP 密码',
      failed: '发送失败：{reason}',
      fromRequired: '请填写发件人地址',
      hostRequired: '请填写 SMTP 服务器',
      notReady: '请先启用邮件服务，并填写服务器和发件人地址',
      passwordRequired: '填写了用户名时需要填写密码',
      rejected: 'SMTP 服务器拒收了邮件：{reason}',
      timeout: 'SMTP 服务器响应超时',
      tls: '加密连接失败：{reason}',
      tooLong: '有内容过长',
    },
    license: {
      readOnly: '平台当前只能查看，暂时无法修改，请联系平台管理员',
      notActive: '平台当前只能查看，暂时无法修改，请联系平台管理员',
      domainQuota: '平台的站点数已达上限，暂时无法添加，请联系平台管理员',
      nodeQuota: '授权允许 {max} 台节点，现在已有 {used} 台',
      noRepository: '版本仓库只对有授权的主控开放：请先激活授权',
      repoTokenExpired: '版本仓库的下载令牌已过期：授权很久没有续期了',
      noKey: '这个程序没有内置授权公钥，无法校验授权；正式发布的版本带有公钥',
      badPortalUrl: '授权站地址（license.portal_url）不是 http(s) 地址',
      notActivated: '主控还没有激活授权',
      codeInvalid: '授权码不存在，请核对后重新输入',
      revoked: '这份授权已被吊销',
      suspended: '这份授权已被暂停',
      expired: '这份授权的合同期已结束，请在授权站续费',
      notStarted: '这份授权还没到生效日期',
      instancesFull: '这份授权的实例名额已用完：先在授权站释放其他实例',
      instanceUnknown: '授权站不认识这台主控：请用授权码重新激活',
      instanceReleased: '这台主控已被授权站释放：请用授权码重新激活',
      offlineOnly: '这台主控在授权站上是离线授权：请上传新签发的离线授权文件',
      clockSkew: '主控的时钟与授权站相差超过 5 分钟，请校准时间（NTP）后重试',
      portalBusy: '授权站暂时繁忙，请稍后重试',
      portalError: '授权站返回错误（HTTP {status}）：{detail}',
      portalUnreachable: '无法连接授权站 {portal}：{detail}',
      portalBadAnswer: '授权站的回应无法使用：{detail}',
      stateUnwritable: '无法写入授权文件：{detail}',
      instanceCorrupt: '实例密钥文件 {path} 已损坏，请人工修复或删除（删除后是一个新实例）',
      noStateDir: '没有配置授权目录（license.dir）',
      fileInvalid: '这不是有效的授权文件，或签名校验失败',
      unbound: '这份授权没有绑定实例：授权现在只能从授权站取得，请用授权码激活',
      otherInstance: '这份授权属于实例 {instance}，不是本机（{self}）',
      notOffline: '这不是离线授权文件：在线授权请用授权码激活',
      fileExpired: '这份授权文件已经过期',
      offlineNoRenew: '离线授权不会自动续期：请上传授权站新签发的文件',
    },
    billing: {
      adjustTooLarge: '单次调整金额不能超过 ¥{max}',
      adjustZero: '调整金额不能为 0',
      amountRange: '充值金额需在 ¥{min} 到 ¥{max} 之间',
      channelError: '支付宝暂时无法发起支付：{reason}',
      insufficientBalance: '当前余额 ¥{balance}，扣减后不能低于 0',
      methodUnavailable: '该支付方式暂不可用，请换一种方式',
      noteRequired: '请填写调整原因',
      noteTooLong: '调整原因最多 {max} 个字',
      queryFailed: '向支付宝查询订单失败：{reason}',
      tooManyPending: '未支付的订单已有 {max} 笔，请等它们过期（{minutes} 分钟）后再充值',
      unavailable: '在线充值暂未开放',
    },
    payment: {
      alipayPublicKeyRequired: '请填写支付宝公钥',
      appIDRequired: '请填写 AppID',
      badAlipayCert: '支付宝公钥证书格式不正确，应为 RSA 证书',
      badAlipayPublicKey: '支付宝公钥格式不正确，应为 RSA 公钥',
      badAmountRange: '单笔最低金额不能小于 ¥0.01，最高金额不能超过 ¥{max}，且不能低于最低金额',
      badAppCert: '应用公钥证书格式不正确，应为 RSA 证书',
      badAppID: '「{value}」不是有效的支付宝 AppID',
      badBaseURL: '「{value}」不是有效的访问地址，格式如 https://cdn.example.com',
      badPrivateKey: '应用私钥格式不正确，应为 RSA 私钥',
      badRootCert: '支付宝根证书中没有 RSA 证书',
      badSignMode: '不支持的接口加签方式：{value}',
      baseURLRequired: '请先填写用户台访问地址，再启用支付宝',
      certKeyMismatch: '应用公钥证书与应用私钥不匹配',
      certsRequired: '公钥证书模式需要同时上传应用公钥证书、支付宝公钥证书和支付宝根证书',
      encryptionKeyMissing: '主控未配置加密密钥（control.yaml 的 secrets.encryption_key），无法保存应用私钥',
      noProduct: '请至少开启一种支付产品',
      presetOutOfRange: '快捷金额 ¥{value} 超出了单笔金额范围',
      privateKeyRequired: '请填写应用私钥',
      subjectTooLong: '订单标题最多 {max} 个字',
      tooManyPresets: '快捷金额最多 {max} 个',
    },
    credential: {
      nameTooLong: '备注最多 {max} 个字',
    },
    clickhouse: {
      addrRequired: '请填写服务器地址',
      badAddr: '「{addr}」不是「主机:端口」格式',
      badDatabase: '「{database}」不能用作数据库名（只能用字母、数字和下划线，且不能以数字开头）',
      badDays: '{table} 的保留天数必须在 {min} 到 {max} 天之间',
      badHigh: '清理阈值必须在 {min}% 到 {max}% 之间',
      badKeep: '始终保留的天数必须在 {min} 到 {max} 天之间',
      badLow: '清理目标必须在 {min}% 到 {max}% 之间（至少比清理阈值低 5%）',
      busy: '另一个主控实例正在清理，请稍后再试',
      connectFailed: '无法连接 ClickHouse：{error}',
      noDatabase: '服务器上没有数据库 {database}，勾选「初始化表结构」后保存即可自动创建',
      notConfigured: '还没有配置 ClickHouse 服务器',
      notConnected: 'ClickHouse 未连接',
      schemaFailed: '初始化表结构失败：{error}',
      unknownTable: '未知的数据表：{table}',
    },
    quota: {
      topUpEmpty: '请填写要增加的流量或请求数',
    },
    consoleTLS: {
      badSite: '未知的控制台',
      certInUse: '已开启 HTTP 自动跳转 HTTPS，请先关闭跳转再删除证书',
      domainRequired: '请先填写并保存该控制台的域名',
      lockFromOtherHost: '请先通过 {domain} 打开后台，再开启「只允许通过后台域名访问后台」（当前是 {host}）',
      noUsableCert: '{domain} 还没有有效的证书，请先申请或上传证书，再开启 HTTPS 跳转',
      sameDomain: '前台和后台不能使用同一个域名',
    },
    controlTLS: {
      badDomain: '「{value}」不是有效的域名（不能是 IP 或通配符）',
      badMode: '未知的通信方式：{value}',
      badPort: '端口必须在 1 到 65535 之间',
      certExpired: '证书当前无效（有效期至 {not_after}）',
      certInUse: '节点正在使用这张证书，请先把节点通信方式改为「关闭」',
      certNotForDomain: '这张证书只包含 {names}，不包含 {domain}',
      domainChanged: '证书申请期间域名被改成了其他值，请重新申请',
      domainRequired: '请先填写并保存通信域名',
      emailRequired: '申请证书需要填写联系邮箱',
      httpsRequired: '主控只接受 HTTPS 的节点请求',
      noUsableCert: '还没有对该域名有效的证书，请先申请或上传证书',
      nodesOnHTTP: '还有 {count} 个在线节点在使用 HTTP：{nodes}',
    },
    cert: {
      notYours: '这张证书属于其他账号',
      bindingUnavailable: '当前平台未启用按域名配置证书',
      expired: '这张证书已经在 {not_after} 过期了',
      invalidPEM: '证书内容不是有效的 PEM 格式 X.509 证书',
      keyMismatch: '私钥和证书不匹配',
      notCovering: '这张证书只覆盖 {names}，不包含 {host}',
      notUsable: '证书 #{id} 已过期或已吊销',
    },
    linePool: {
      lineRequired: '请选择解析线路',
      lineUnsupported: '该接入域名（{zone}）的 DNS 套餐不支持「{line}」线路，升级解析套餐后才能使用',
      wrongGroup: '这个线路池属于另一个线路组',
      roleInvalid: '主备类型只能是 primary 或 backup（收到 {value}）',
    },
    acme: {
      emailRequired: '申请证书需要填写邮箱',
      emailRequiredForZerossl: '使用 ZeroSSL 需要先填写邮箱才能获取 EAB 凭据',
      issuanceInFlight: '{domain} 已有一个签发任务正在进行，请等它结束',
      issuanceOnAnotherReplica: '另一个控制面实例正在签发这张证书',
      tosRequired: '需要先同意 CA 的服务条款',
      unknownCA: '不支持的证书颁发机构：{value}',
      zerosslNoStaging: 'ZeroSSL 没有测试环境；请用正式环境签发，或改用 Let\'s Encrypt 做测试',
      notConfigured: '平台还没有配置证书签发功能',
      challengeNotServed: '证书颁发机构访问 {domain} 的验证文件时返回 {status}（它访问的是 {ip}）。通常是验证文件还没同步到那台节点，或者那台节点不是解析指向的节点。',
      challengeUnreachable: '证书颁发机构连不上 {domain} 的 80 端口，检查节点防火墙和解析是否正确',
      rateLimited: '证书颁发机构对 {domain} 限流了，请稍后再试（失败次数过多也会触发）',
      dnsProblem: '证书颁发机构解析不了 {domain}，请先确认解析已经生效',
      caaForbids: '{domain} 的 CAA 记录不允许这家机构签发证书',
      issueFailed: '{domain} 的证书签发失败：{detail}',
    },
    auth: {
      badCredentials: '用户名或密码不正确',
      inactiveUser: '该账号已被停用',
      wrongPortal: '该账号不能从这个控制台登录',
      throttled: '尝试次数过多，请 {minutes} 分钟后再试',
      badMfaCode: '动态码不正确或已经用过，请输入新的动态码',
      mfaTicketExpired: '验证超时，请重新输入密码',
      resetUnavailable: '这个账号不能通过短信找回密码（没有已验证的手机号），请联系平台管理员',
      codeLoginOff: '当前未开放验证码登录',
      codeLoginUnavailable: '没有可用这个手机号或邮箱验证码登录的账号，请检查后重试，或使用密码登录',
      subBadCredentials: '主账号、子用户名或密码不正确',
      passkeyOff: '当前未开放通行密钥登录',
      mainAccountOnly: '仅主账号可以操作，子用户无此权限',
    },
    passkey: {
      needsDomain: '通行密钥需要通过 HTTPS 域名访问控制台（不支持 IP 地址）',
      originMismatch: '页面地址与控制台地址不一致，请刷新后重试',
      expired: '通行密钥验证已超时，请重试',
      failed: '通行密钥验证失败，请重试',
      unknown: '该通行密钥未在本平台登记，可能已被删除，请使用密码登录后重新添加',
      exists: '该通行密钥已经添加过了',
      limit: '每个账号最多添加 {max} 个通行密钥，请先删除不用的',
      nameInvalid: '请填写通行密钥名称，最多 {max} 个字符',
    },
    subUser: {
      nameInvalid: '子用户名为 3-32 位字母、数字或 _ . -，以字母或数字开头',
      nameTaken: '已有同名子用户',
      limit: '每个账号最多创建 {max} 个子用户',
      remarkTooLong: '备注最多 {max} 个字符',
      badStatus: '子用户状态只能是启用或停用',
    },
    cacheJob: {
      noNodes: '当前没有在线节点可以下发',
      noTargets: '请至少填写一个目标',
      quota: '最近一小时的缓存任务过多，请稍后再试',
      scheduleNotAllowed: '只有预热任务可以定时执行',
      scheduleTooFar: '预热最多只能提前 {days} 天安排',
      targetHasDotDot: '{value} 不能包含 ..',
      targetNotURL: '{value} 不是一个网址，也不是以 / 开头的路径',
      targetOffSite: '{value} 不属于 {host} —— 任务只能操作自己站点的资源',
      tooManyTargets: '每个任务最多 {max} 个目标，当前 {got} 个',
      unknownKind: '不支持的缓存任务类型：{value}',
    },
    cnameZone: {
      hasGroups: '该域名正被 {count} 个线路组使用，请先把它们指到别的域名',
      inUse: '有 {count} 个线路组正在使用 {domain}，请先把它们迁到别的域名',
      invalid: '请填写主域名，例如 example.com —— 不要带协议、路径、端口或开头的点',
      notApex: '只能填主域名（example.com），不能填它的子域名',
      providerRequired: '请选择一个 DNS 提供商',
      ttlRange: 'TTL 只能填 {min} 到 {max} 秒之间',
      ttlBelowPlan: '该接入域名的解析套餐（{plan}）最低只支持 {min} 秒的 TTL',
    },
    dns: {
      lineGroupNoResolveValue: '套餐绑定的线路组没有解析值，CNAME 无处可指',
      cnameDomainBound: '接入域名 {domain} 还绑定在套餐「{package}」上',
      encryptionKeyMissing: '没有配置加密密钥 —— 请先在 control.yaml 里设置 secrets.encryption_key，再保存 DNS 凭据',
      unsupportedProvider: '不支持的 DNS 提供商类型：{value}',
      cnameZoneMissing: '套餐「{package}」绑定的接入域名 #{id} 读取失败，可能已被删除',
      lineGroupMissing: '套餐「{package}」绑定的线路组 #{id} 读取失败，可能已被删除',
      providerUnavailable: 'DNS 服务商账号 #{id} 无法使用：{detail}',
      providerListFailed: '查询 {zone} 的解析记录失败：{detail}',
      providerWriteFailed: '写入解析记录 {name} 失败：{detail}',
      cnameNameTaken: '{name} 上已经有一条 {type} 记录（值 {value}，记录 ID {record_id}），CNAME 不能与其他记录同名',
      cnameNoZone: '{host} 不在平台的任何接入域名下，没有可用的 DNS 账号去删除它',
      lineGroupValueUnresolvable: '线路组解析值 {target} 在公网 DNS 查不到 IP，使用它的站点将无法访问',
      lineValueNameTaken: '{name} 上已经有一条 {type} 记录（值 {value}，记录 ID {record_id}），线路组的解析值必须用来放节点的 A 记录',
      lineNoActiveNodes: '线路组「{group}」里没有可用节点（需要状态正常且有公网 IPv4），{name} 解析不到任何 IP',
      lineNoDefaultFallback: '{name} 只在「{line}」线路上有记录。其他线路的访问者会走默认线路，而默认线路上没有记录，等于解析不到。',
      supportedLinesFailed: '读取 {zone} 可用解析线路失败：{detail}',
    },
    domain: {
      badCityName: "城市名称不合法：{value}（最多 64 个字，不能包含 {'|'} 或换行）",
      badOriginHost: '「{value}」不是合法的主机名',
      badRealIpHeader: '「{value}」不是合法的请求头名称，只能包含字母、数字和连字符',
      challengeDifficultyRange: '难度只能填 8 到 24 之间',
      challengeTTLRange: '有效期只能填 60 到 86400 秒之间',
      hostNotVerified: '{host} 还没有通过 CNAME 验证，验证通过后才能申请证书',
      siteNotServing: '站点已停用，{host} 暂时不能申请证书',
      cnameLookupFailed: '查询 {host} 的解析失败：{detail}',
      cnameNotFound: '{host} 还没有 CNAME 记录，请添加一条指向 {target}',
      cnamePointsElsewhere: '{host} 当前指向 {resolved}，而不是 {target}',
      cnameTargetMissing: '公网 DNS 查不到 {target}：平台的 CNAME 记录没有生效。请检查接入域名绑定的 DNS 账号是否就是该域名当前使用的解析服务商',
      exemptPathNotAbsolute: '放行路径 {value} 必须以 / 开头',
      exemptPathTooLong: '放行路径 {value} 太长了',
      failBanDurationRange: '封禁时长只能填 {min} 到 {max} 秒',
      failBanMaxRange: '失败次数只能填 {min} 到 {max} 次',
      failBanWindowRange: '统计周期只能填 {min} 到 {max} 秒',
      forbidden: '没有权限操作这个站点',
      geoBanDurationRange: '封禁时长只能填 {min} 到 {max} 秒',
      geoBlockNoRegions: '请至少选择一个国家或地区',
      hostNotInSite: '{host} 不是这个站点的域名',
      hostnameRequired: '请填写域名',
      nameRequired: '请填写名称',
      noCnameTarget: '该站点还没有 CNAME 目标 —— 它所属套餐没有绑定接入域名',
      originNotAHost: '回源地址只能填域名或 IP —— 不要带协议、端口、路径或空格',
      originNotPublic: '回源地址必须是公网地址 —— 不允许内网、回环和链路本地地址',
      packageNotActive: '套餐 {id} 不在该账号的有效套餐里',
      packageRequired: '请选择一个套餐',
      tooManyCities: '城市最多 {max} 个',
      tooManyExemptPaths: '最多只能配置 {max} 条放行路径',
      unknownCCLevel: '不支持的 CC 防护等级：{value}',
      unknownCCAutoLevel: '不支持的自适应 CC 灵敏度：{value}',
      unknownCCAutoMode: '不支持的自适应 CC 验证方式：{value}',
      unknownChallengeMode: '不支持的验证模式：{value}',
      unknownGeoBlockAction: '不支持的区域屏蔽处置方式：{value}',
      unknownGeoBlockMode: '不支持的区域屏蔽模式：{value}',
      unknownProxyMode: '不支持的代理模式：{value}',
      unknownRegion: '未知的国家或地区代码：{value}',
      unknownSslMode: '不支持的 SSL 模式：{value}',
      unknownSubdivision: '未知的省份代码：{value}',
      upstreamLimitRange: '回源并发上限只能填 0 到 {max} 之间',
    },
    firewall: {
      badPort: '「{value}」不是有效的端口或端口范围（1-65535，例如 443 或 8000-8100）',
      blockMode: '未知的拉黑方式：{mode}',
      noPorts: '指定端口模式下至少要填一个端口',
      limitRange: '数值超出范围：必须在 {min} 到 {max} 之间',
      tooManyPorts: '每个列表最多 {max} 个端口或端口范围',
      unknownScope: '未知的封禁范围：{scope}',
    },
    pages: {
      badMode: '页面「{key}」的模式无效：{mode}',
      dropNotAllowed: '页面「{key}」不能设置为直接断开连接',
      graceRange: '宽限期必须在 0 到 {max} 小时之间',
      htmlRequired: '页面「{key}」选择了自定义 HTML，但内容为空',
      htmlTooLarge: '页面「{key}」的 HTML 不能超过 {max} KB',
      messageTooLong: '页面「{key}」的说明文字不能超过 {max} 个字符',
      statusRange: '页面「{key}」的状态码必须在 400 到 599 之间',
      titleRequired: '页面「{key}」选择了自定义文字，需要填写标题',
      titleTooLong: '页面「{key}」的标题不能超过 {max} 个字符',
      unknownKey: '没有名为「{key}」的页面',
    },
    subscription: {
      daysRange: '时长必须在 {min} 到 {max} 天之间',
      expiryBeforeStart: '到期时间不能早于开始时间',
      expiryInPast: '到期时间必须晚于现在',
      notCancelled: '这个套餐没有被取消，不需要恢复',
      packageInactive: '套餐「{name}」已下架，不能分配',
      packageNotFound: '套餐不存在',
      resumeExpired: '这个套餐已经过期，请使用续期',
      userNotFound: '用户不存在',
    },
    ipList: {
      badEnforcement: '拦截方式只能是 {edge} 或 {kernel}',
      badKind: '名单类型只能是 {allow} 或 {deny}',
      batchTooLarge: '每批最多 {max} 个地址，当前 {got} 个',
      full: '名单已满',
      invalidTarget: '不是有效的 IP 地址或 CIDR 网段',
      noAddresses: '请至少填写一个地址',
      noteTooLong: '备注最多 {max} 个字符',
      targetTooBroad: '这个网段范围太大，不能封禁',
      unknownScope: '不支持的作用范围：{value}',
    },
    node: {
      aliasTooLong: '昵称最多 {max} 个字符',
      cannotInitFromStatus: '当前状态是「{status}」，不能激活',
      fingerprintTaken: '该机器指纹已经用另一个令牌注册过了',
      invalidRegisterToken: '注册令牌无效',
      ipNotPublic: '这不是一个公网可路由的地址',
      noActiveAgentToken: '节点 {id} 没有可用的 Agent 令牌',
      notAnIP: '{value} 不是一个 IP 地址',
      primaryIPImmutable: '主地址是节点心跳上报的，不能删除',
      regionNotRegistered: '地区代码 {region} 还没有登记 —— 请先到「地区管理」添加',
      registerFieldsRequired: '注册令牌和机器指纹都不能为空',
      tokenExpired: '注册令牌已过期',
      tokenUsed: '注册令牌已经用过了',
    },
    nodeGroup: {
      cnameZoneRequired: '请选择一个接入域名',
      hasMembers: '该线路组还有 {count} 个节点，请先把它们移到别的组',
      resolveValueNotUnderZone: '解析值 {value} 必须是 {zone} 的子域名',
      resolveValueRequired: '请填写解析值',
      lineInvalid: '解析线路代码 {value} 不合法（只能是小写字母、数字和下划线）',
    },
    l4: {
      badStatsRange: '不支持的统计时间范围：{range}',
      badBalance: '负载方式只能是轮询或源 IP 哈希',
      badProtocol: '转发协议只能是 TCP、UDP 或 TCP+UDP',
      badProxyProtocol: 'PROXY 协议只能是关闭、v1 或 v2',
      badRange: '端口范围需在 {min}–{max} 之间，起始端口不能大于结束端口',
      nameLength: '规则名称需为 1–{max} 个字符',
      noFreePort: '端口范围内已没有空闲端口，请联系客服',
      originFormat: '第 {n} 个源站「{value}」格式不正确，应为 地址:端口，IPv6 地址需加方括号',
      originNotPublic: '第 {n} 个源站「{value}」不是公网地址，内网、本机和链路本地地址不能作为源站',
      originRepeated: '第 {n} 个源站「{value}」重复了',
      originRequired: '请至少填写一个源站',
      packageNotActive: '所选套餐不是您当前有效的套餐',
      packageRequired: '请选择套餐',
      portRange: '监听端口需在 {min}–{max} 之间',
      portReserved: '端口 {port} 是系统保留端口，请换一个',
      portTaken: '端口 {port} 已被占用，请换一个或留空自动分配',
      remarkLength: '备注最多 {max} 个字符',
      tooManyOrigins: '最多填写 {max} 个源站',
    },
    package: {
      cnameBindingIncomplete: '接入域名、线路组、CNAME 解析值需要同时填写，或者都不填',
      cnameValueInvalid: 'CNAME 解析值 {value} 不合法，只能用字母、数字和短横线，多段用点分隔',
      cnameZoneNotFound: '接入域名 {id} 不存在',
      nodeGroupNoResolveValue: '线路组「{name}」没有解析值，请先给它设置解析值',
      nodeGroupNotFound: '线路组 {id} 不存在',
      descTooLong: '套餐描述最多 {max} 个字符',
      nameRequired: '请填写套餐名',
      unknownCnameMode: '不支持的 CNAME 生成模式：{value}',
      valueOutOfRange: '{field} 只能填 0 到 {max} 之间（0 表示不限）',
      groupNotFound: '套餐分组 {id} 不存在',
      noWaf: '当前套餐「{package}」不包含 WAF，升级套餐后才能使用',
      noCustomCc: '当前套餐「{package}」不包含自定义 CC 规则，可以使用 CC 防护等级',
      noWebsocket: '当前套餐「{package}」不包含 WebSocket',
      noHttp3: '当前套餐「{package}」不包含 HTTP/3',
      noCustomCert: '当前套餐「{package}」不支持上传证书，可以申请免费证书',
      noOpenapi: '您的套餐都不包含 OpenAPI，升级套餐后才能使用 API 密钥',
      noFeature: '当前套餐「{package}」不包含该功能',
      siteQuota: '套餐「{package}」最多 {max} 个站点，已达上限',
      domainQuota: '套餐「{package}」最多 {max} 个域名（含子域名），已达上限',
      apexQuota: '套餐「{package}」最多 {max} 个主域名，已达上限',
      ruleQuota: '套餐「{package}」每个站点最多 {max} 条规则，已达上限',
      noL4: '当前套餐「{package}」不包含应用加速，升级套餐后才能使用',
      l4Quota: '套餐「{package}」最多 {max} 条应用加速规则，已达上限',
    },
    packageGroup: {
      descTooLong: '分组描述最多 {max} 个字符',
      hasPackages: '该分组下还有 {count} 个套餐，请先把它们移到别的分组',
      nameRequired: '请填写分组名称',
      nameTaken: '已经有同名的套餐分组了',
      nameTooLong: '分组名称最多 {max} 个字符',
    },
    publish: {
      nothingToPublish: '没有可发布的内容：平台上还没有站点',
    },
    region: {
      codeInUse: '还有 {count} 个节点在用「{code}」—— 确认后会一并迁到新代码，或者只改名称、保留代码',
      codeInvalid: '地区代码只能包含字母、数字、短横线和下划线，长度 1-32',
      hasNodes: '该地区下还有 {count} 个节点，请先把它们移到别的地区',
      nameRequired: '请填写地区名称',
    },
    registration: {
      badUsername: '用户名为 3–32 位字母、数字或 _ . -，以字母或数字开头',
      usernameTaken: '该用户名已被注册',
      emailTaken: '该邮箱已注册，请直接登录',
      phoneTaken: '该手机号已绑定其他账号',
      agreeRequired: '请先阅读并同意用户协议',
      closed: '当前未开放注册',
      noDefaultPackage: '还没有配置默认套餐，无法开放注册',
      passwordTooShort: '密码至少 {min} 位',
      rateLimited: '该地址注册太频繁，请稍后再试',
    },
    rule: {
      aclBadHeader: '「{value}」不是合法的请求头名称',
      aclBadMatch: '匹配条件格式不正确',
      aclBadValue: '「{value}」不符合这种规则类型',
      aclNoValues: '规则没有任何匹配值，至少填一个',
      aclTooManyValues: '一条规则最多 {max} 个值，更多的请放进 IP 名单',
      aclUnknownAction: '不支持的访问控制动作：{value}',
      botBadSignature: '匹配方式格式不正确：正则和包含二选一',
      botUnknownAction: '不支持的机器人规则动作：{value}',
      browserTTLRange: '浏览器缓存时间只能填 -1（跟随）或 0 到 {max} 之间',
      ccBadConditions: '匹配条件格式不正确',
      ccBadCountStatus: '「{value}」不是合法的状态码，可填 404 或 5xx 这样的形式',
      ccBadEscalation: '阶梯处置格式不正确',
      ccBadParams: '处置参数格式不正确',
      ccDimensionsEmpty: 'CC 统计维度不能为空',
      ccPathNotAbsolute: '路径「{value}」必须以 / 开头',
      ccPathTooLong: '路径最多 512 个字符',
      ccStatusRange: '响应状态码只能是 4xx 或 5xx',
      ccTTLRange: '处置时长最多 {max} 秒',
      ccThresholdRange: '阈值只能填 1 到 1000000 之间',
      ccTooManyDimensions: '统计维度最多 {max} 个',
      ccTooManyTiers: '阶梯处置最多 {max} 级',
      ccUnknownAction: '不支持的处置动作：{value}',
      ccUnknownMethod: '不支持的请求方法：{value}',
      ccUnknownMitigation: '不支持的处置方式：{value}',
      ccUnknownPathMode: '不支持的路径匹配方式：{value}',
      ccWindowRange: '统计周期只能填 1 到 86400 秒',
      notAStatusCode: '{value} 不是一个 HTTP 状态码',
      patternEmpty: '匹配规则不能为空，否则会匹配所有请求',
      patternInvalid: '「{value}」不是合法的正则表达式',
      patternTooLong: '匹配规则最多 {max} 个字符',
      staleIfErrorRange: '回源失败时的宽限时间超出范围',
      staleWhileRevalidateRange: '后台revalidate的宽限时间超出范围',
      statusTTLRange: '状态码 {code} 的缓存时间超出范围',
      ttlRange: '缓存时间只能填 0 到 {max} 之间',
      unknownStatus: '不支持的规则状态：{value}',
      unsupportedAclType: '不支持的访问控制类型：{value}',
      unsupportedCcDimension: '不支持的 CC 统计维度：{value}',
      wafBadDefinition: 'WAF 规则格式不正确',
      wafNoTargets: '至少选择一个检测位置',
      wafScoreRange: '分值只能填 {min} 到 {max}',
      wafUnknownCategory: '不支持的 WAF 分类：{value}',
      wafUnknownTarget: '不支持的检测位置：{value}',
    },
    settings: {
      unknownLogo: '没有这个 LOGO 位置',
      logoEmpty: 'LOGO 文件是空的',
      logoTooLarge: 'LOGO 不能超过 {max} KB',
      logoBadSvg: 'SVG 文件无法解析，请导出为标准 SVG 后重试',
      unknownBackground: '没有这个背景图片位置',
      backgroundEmpty: '图片是空的',
      backgroundTooLarge: '背景图片不能超过 {max} MB',
      backgroundBadType: '背景图片支持 PNG、JPG、WebP 或 SVG 格式',
      logoBadType: 'LOGO 须为 PNG、JPG、WebP、GIF 或 SVG 图片',
      agreementTooLong: '协议内容最多 {max} KB',
      footerBadLinkKind: '不支持的页脚链接类型：{value}',
      footerBadLinkURL: '第 {n} 个页脚链接的地址须以 http:// 或 https:// 开头',
      footerCopyrightTooLong: '版权信息最多 {max} 个字符',
      footerLinkNoText: '第 {n} 个页脚链接还没有填写名称',
      footerLinkTextTooLong: '第 {n} 个页脚链接的名称最多 {max} 个字符',
      footerTooManyLinks: '页脚链接最多 {max} 个',
      loginNoticeEmpty: '登录页公告已开启，请填写公告内容',
      noticeTooLong: '公告内容最多 {max} KB',
      registerNoticeEmpty: '注册页公告已开启，请填写公告内容',
      badAgreementMode: '协议的提供方式不正确',
      badAgreementURL: '协议链接须以 http:// 或 https:// 开头',
      badWebsiteURL: '官网地址须以 http:// 或 https:// 开头',
      mailNotReady: '请先在 邮件服务 中启用并配置邮件，再开启注册验证邮箱',
      smsNotReady: '请先在 短信服务 中启用并配置短信，再开启注册验证手机',
      badNavbarHeight: '导航栏高度须在 {min}–{max} 像素之间',
      badMenuWidth: '菜单宽度须在 {min}–{max} 像素之间',
      badSkin: '{value} 不是可选的主题色',
      badLevelBadge: '没有这个 VIP 标志样式',
      defaultPackageRequired: '开放注册前需要先设置默认套餐',
      faviconEmpty: '图标文件是空的',
      faviconNotIco: '图标必须是 .ico 文件',
      faviconTooLarge: '图标最大 {max} KB',
      tooLong: '{field} 最多 {max} 个字符',
    },
    stats: {
      unavailable: '统计功能需要 ClickHouse，当前不可用',
    },
    task: {
      autoRenewed: '「{package}」已从余额自动续费 ¥{amount}，有效期至 {until}',
      autoRenewError: '续费未能完成：数据库出错，请稍后重试',
      autoRenewGone: '套餐 #{id} 已不存在',
      autoRenewNotDue: '无需续费：套餐有效期至 {until}',
      autoRenewOff: '客户已关闭自动续费，未扣费',
      badResultStatus: '任务结果状态只能是 success 或 failed，收到 {value}',
      certDeleted: '证书 #{cert_id} 已被删除',
      certIssued: '{domain} 的证书已由 {issuer} 签发',
      certRenewed: '{domain} 的证书已由 {issuer} 续期',
      clickhouseDroppedBoth: '删除了 {days} 天的数据，清空了 {logs} 张系统日志表，释放 {size}',
      clickhouseDroppedDays: '删除了 {days} 天的数据，释放 {size}',
      clickhouseDroppedLogs: '清空了 {logs} 张系统日志表，释放 {size}',
      clickhouseFailed: '清理失败：{error}',
      clickhouseNothing: '没有需要清理的数据',
      clickhouseStillFull: '清理后磁盘仍高于清理目标：剩下的数据都在始终保留的天数内，或者磁盘被其他数据占用',
      l4RuleDeleted: '应用加速规则 #{id} 已被删除',
      l4CnameNotBound: '规则所属套餐已不再分配 CNAME（接入域名、线路组或 CNAME 值未设置）',
      cnameNotBound: '站点所属套餐已不再分配 CNAME（接入域名、线路组或 CNAME 值未设置）',
      aliasActivated: '{host} 解析验证通过，节点开始加速',
      aliasAlreadyActive: '{host} 已经验证过，无需再验证',
      aliasDeleted: '别名 {host} 已被删除',
      cnamePublished: '已发布 {host} → {target}（{action}）',
      cnameRemoved: '站点已删除，已删除它的 CNAME 记录 {host}',
      cnameAlreadyGone: '{host} 已不存在，无需删除',
      cnameStillUsed: '{host} 仍在被 {user} 使用，保留不删',
      internal: '内部错误：{detail}',
      lineGroupDeleted: '线路组 #{id} 已被删除',
      lineNotBound: '该线路组还没有配置解析值和接入域名，没有可发布的记录',
      linePublished: '{host} 已指向 {count} 个节点 IP',
      linePublishedWithBackup: '{host} 已指向 {count} 个 IP，其中 {lines} 条线路启用了备用地址',
      lineUnchanged: '{host} 的解析已是最新：{count} 个节点 IP，无需改动',
      lineUnchangedWithBackup: '{host} 的解析已是最新：{count} 个 IP，{lines} 条线路仍在使用备用地址',
      notSystemTask: '只有系统任务可以重试',
      renewNoNames: '证书上的域名都已不属于 {domain}，无需续期',
      renewNoSite: '证书 #{cert_id} 不属于任何站点，无需续期',
      renewSuperseded: '已续期：证书 #{cert_id} 覆盖了相同的域名',
      running: '任务正在执行，请稍后再试',
      siteActivated: '{host} 解析验证通过，站点已生效',
      siteAlreadyActive: '站点当前状态为 {status}，无需验证',
      siteDeleted: '站点 #{id} 已被删除',
      unsupportedType: '不支持的任务类型：{value}',
      waitingForPublish: '等待站点的 CNAME 记录发布完成',
    },
    user: {
      encryptionKeyMissing: '没有配置加密密钥 —— 请先在 control.yaml 里设置 secrets.encryption_key，再保存证件号码',
      noIdentity: '该账号没有保存证件号码',
      passwordRequired: '创建用户必须设置密码',
      unknownRealNameStatus: '不支持的实名状态：{value}',
      unknownRealNameType: '不支持的实名类型：{value}',
      unknownStatus: '不支持的用户状态：{value}',
    },
    member: {
      badExp: '经验值为 0 到 {max}',
      badThresholds: '{n} 个 VIP 门槛需从 1 起逐级递增，最大 {max}',
      noteRequired: '请填写调整说明，客户会在记录里看到',
      noteTooLong: '说明最多 {max} 个字',
      badChange: '调整数量为 1 到 {max}',
      expBelowZero: '该客户只有 {n} 经验，不能扣得更多',
      noCustomer: '找不到这个客户，可能已被删除',
      growthBelowZero: '该客户只有 {n} 成长值，不能扣得更多',
    },
    userGroup: {
      hasMembers: '该用户组还有 {count} 个成员，请先把他们移到别的组',
    },
    deployment: {
      badResultStatus: '下发结果状态不合法：{value}',
    },
  },
}
